var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _ellipse, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    viewBox: "0 0 1600 1200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8E8;}\n\t.st1{fill:#161616;}\n\t.st2{fill:none;stroke:#E8E8E8;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{opacity:0.17;fill:#666666;}\n\t.st4{fill:#161616;stroke:#161616;stroke-width:2;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#161616;stroke-width:2;stroke-miterlimit:10;}\n\t.st6{opacity:0.15;fill:#666666;}\n\t.st7{opacity:0.12;fill:#666666;}\n\t.st8{opacity:0.18;fill:#666666;}\n\t.st9{fill:#EC615B;}\n\t.st10{opacity:0.22;fill:#666666;}\n\t.st11{opacity:0.3;fill:#666666;}\n\t.st12{opacity:0.19;fill:#666666;}\n\t.st13{opacity:0.16;fill:#666666;}\n\t.st14{opacity:0.28;fill:#666666;}\n\t.st15{opacity:0.26;fill:#666666;}\n\t.st16{opacity:0.56;fill:#EC615B;}\n\t.st17{opacity:0.33;fill:#EC615B;}\n\t.st18{opacity:0.33;}\n\t.st19{fill:#666666;}\n\t.st20{fill:#5222D0;}\n\t.st21{opacity:9.000000e-002;fill:#666666;}\n\t.st22{opacity:0.23;fill:#666666;}\n\t.st23{fill:#161616;stroke:#161616;stroke-miterlimit:10;}\n\t.st24{opacity:0.21;fill:#666666;}\n\t.st25{opacity:0.4;fill:#666666;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1202.3 944c5.2 25.1 10.4 50.1 15.5 75.2 0.4 1.9 3.3 1.1 2.9-0.8-5.2-25.1-10.4-50.1-15.5-75.2-0.4-1.9-3.3-1.1-2.9 0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1219 1021.3c24.7 13 54.2 13.8 79.6 2.2 1.8-0.8 0.2-3.4-1.5-2.6-24.3 11.1-52.9 10.2-76.6-2.2-1.7-0.9-3.2 1.7-1.5 2.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1300.4 1021.8c7.6-26.1 14.4-52.4 20.5-79 0.4-1.9-2.5-2.7-2.9-0.8-6.1 26.5-12.9 52.8-20.5 79-0.5 1.8 2.4 2.6 2.9 0.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1203.5 943.6c36.9 15 79 14.8 115.7-0.5 1.8-0.7 1-3.6-0.8-2.9-36.3 15.2-77.7 15.4-114.1 0.5-1.7-0.8-2.5 2.1-0.8 2.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1194.7 929.5c-0.4 2.3-0.9 4.7-1.1 7.1-0.1 1.2-0.2 2.3 0.7 3.2 1.1 1.1 3.2 1.6 4.6 2.1 2.3 0.8 4.6 1.3 6.9 1.6 1.9 0.3 2.7-2.6 0.8-2.9-3-0.4-5.8-1.1-8.6-2.2-1.9-0.8-1.5-1.3-1.2-3.2 0.3-1.6 0.5-3.2 0.8-4.9 0.2-1.8-2.6-2.7-2.9-0.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1195 930.8c18.8 10.2 42.1 9.7 62.9 10.4 22.4 0.8 45.1-0.3 66-8.9-0.6-0.3-1.2-0.7-1.8-1 1 3 1.2 5.8 0.8 8.9 0.4-0.5 0.7-1 1.1-1.4-2.3 0.8-4.6 1.6-7 2.3-1.8 0.6-1 3.5 0.8 2.9 2.3-0.8 4.6-1.6 7-2.3 0.7-0.2 1-0.7 1.1-1.4 0.4-3.4 0.1-6.4-0.9-9.7-0.2-0.7-1.1-1.4-1.8-1-20.1 8.3-41.9 9.5-63.4 8.8-20.7-0.6-44.5 0-63.2-10.1-1.8-1-3.3 1.6-1.6 2.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1215 1000.3c6.1 10.8 13.9 20.3 23.4 28.4 1.5 1.2 3.6-0.9 2.1-2.1-9.2-7.9-16.9-17.2-22.9-27.7-1-1.8-3.6-0.3-2.6 1.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1209.2 973.8c6.7 11.2 14 21.9 22 32.1 4.1 5.2 8.3 10.2 12.6 15.2 2.6 2.9 6.3 9.1 10.3 9.6 0.5 0.1 1.1-0.3 1.3-0.7 0.4-0.7 0.5-1.2 0.2-2-0.2-0.6-0.7-1.1-1.4-1.1h-0.3c-1.9 0-1.9 3 0 3h0.3c-0.5-0.4-1-0.7-1.4-1.1 1.3-0.6 1.5-1.3 0.5-1.9-0.4-0.4-0.8-0.9-1.2-1.3-1-1.1-2-2.2-3.1-3.3-2-2.2-4-4.4-6-6.7-4-4.7-7.9-9.4-11.6-14.3-7.1-9.3-13.6-19-19.6-29-1-1.7-3.6-0.2-2.6 1.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1205.2 951.2c18.4 27.9 39.7 53.7 63.8 76.8 1.4 1.3 3.5-0.8 2.1-2.1-23.9-23-45.1-48.6-63.3-76.2-1.1-1.6-3.7-0.1-2.6 1.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1228.5 951.8c16.9 26.8 36.4 51.8 58.3 74.7 1.3 1.4 3.5-0.7 2.1-2.1-21.7-22.7-41.1-47.5-57.8-74.1-1-1.6-3.6-0.1-2.6 1.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1256.1 954.1c13.5 18 27.6 35.5 42.5 52.3 1.3 1.5 3.4-0.7 2.1-2.1-14.7-16.7-28.7-33.9-42-51.7-1.1-1.5-3.7 0-2.6 1.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1279.7 953c7.7 11.7 16.5 22.6 26.2 32.7 1.3 1.4 3.5-0.7 2.1-2.1-9.6-9.9-18.1-20.6-25.7-32.1-1.1-1.6-3.7-0.1-2.6 1.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1299.3 949.7c4 5.7 8.4 11.2 13.1 16.3 1.3 1.4 3.4-0.7 2.1-2.1-4.6-4.9-8.8-10.2-12.6-15.7-1.1-1.6-3.7-0.1-2.6 1.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1235.9 934.5c-17.1-10.5-32.2-23.7-44.8-39.2v2.1c1.8-2 3.8-3.5 6.2-4.8 0.8-0.4 1-1.8 0.3-2.4-8.4-6.7-11.3-17.1-13.9-27.1-0.3 0.6-0.7 1.2-1 1.8 4.5-1.7 4-6.1 2-9.8-4.1-7.7-4.1-16.8-5.1-25.4-1.9-17.4-3.5-34.8-4.8-52.3-0.8 0.4-1.5 0.9-2.3 1.3 13.3 7.8 23.9 19 33.3 31.1 9.8 12.5 18.3 26 25.5 40.2 14.3 28.1 23.1 58.8 25.9 90.2 0.2 1.9 3.2 1.9 3 0-2.9-31.9-11.8-63.1-26.3-91.7-7.2-14.1-15.7-27.6-25.4-40.1s-20.7-24.1-34.4-32.2c-0.9-0.5-2.3 0.1-2.3 1.3 1.1 14.5 2.4 29.1 3.9 43.6 0.7 7.1 1.5 14.2 2.3 21.3 0.3 2.7 0.5 5.6 1.2 8.2 0.6 2.2 5.6 10.3 2.6 11.4-0.8 0.3-1.3 1-1 1.8 2.7 10.5 5.8 21.5 14.6 28.5l0.3-2.4c-2.7 1.4-4.8 3-6.9 5.3-0.6 0.6-0.5 1.5 0 2.1 12.8 15.8 28.1 29.1 45.4 39.7 1.9 1.1 3.4-1.5 1.7-2.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1196.8 930.7c7.5-1.1 15-1.8 22.5-2.2 1.9-0.1 1.9-3.1 0-3-7.8 0.4-15.6 1.2-23.3 2.3-1.9 0.3-1.1 3.2 0.8 2.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1252.9 894.5c0.4-32.8 14.9-62.9 29.1-91.8-0.7 0.2-1.4 0.4-2.1 0.5 1.9 1.1 3.8 2.3 5.7 3.4 1 0.6 2.3-0.2 2.3-1.3 0-11.2 11.8-19.8 19-27.2 8.1-8.3 16.3-16.7 24.4-25-0.9-0.4-1.7-0.7-2.6-1.1 1.9 17.1 3.7 34.2 4.4 51.4 0.3 8.4 0.4 16.8 0 25.2-0.3 6.7 1 24.3-9 24.3-1.4 0-1.8 1.6-1.1 2.6 6.4 8 0.6 17.6-4.6 24.3-4.4 5.8-8.9 11.4-13.1 17.4-9.1 12.9-17.2 26.4-24.4 40.4-0.9 1.7 1.7 3.2 2.6 1.5 8.6-16.7 18.5-32.7 29.7-47.7 7.7-10.2 22.6-24.8 11.9-38-0.4 0.9-0.7 1.7-1.1 2.6 6.4 0 9.7-5.5 10.7-11.3 1.7-9.6 1.6-19.8 1.6-29.6-0.1-21.1-2.4-42.1-4.7-63-0.1-1.2-1.6-2.1-2.6-1.1-9.5 9.8-19.1 19.5-28.6 29.3-6.8 7-15.6 14.4-15.7 25 0.8-0.4 1.5-0.9 2.3-1.3-1.9-1.1-3.8-2.3-5.7-3.4-0.7-0.4-1.7-0.2-2.1 0.5-14.5 29.4-29.1 59.9-29.5 93.3 0.2 2 3.2 2 3.2 0.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1320.3 780c-27 46.5-45.6 97.6-54.9 150.6-0.3 1.9 2.6 2.7 2.9 0.8 9.2-52.7 27.7-103.5 54.6-149.8 1-1.8-1.6-3.3-2.6-1.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1190.7 816.4c22.4 38.2 41.2 78.5 56.1 120.2 0.6 1.8 3.5 1 2.9-0.8-15-42-33.9-82.5-56.4-120.9-1-1.6-3.6-0.1-2.6 1.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1183.2 849.3c10.9 2.6 22.1 5.4 30.2 13.5 1.4 1.4 3.5-0.8 2.1-2.1-8.5-8.5-20.1-11.6-31.5-14.3-1.9-0.4-2.7 2.5-0.8 2.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1204.9 836.7c0.6-8.3 2.7-16.3 6.2-23.9 0.8-1.7-1.8-3.3-2.6-1.5-3.7 8.1-6 16.5-6.6 25.4-0.1 1.9 2.9 1.9 3 0z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1277.1 807.7c7.5 10.9 9.2 23.8 9.6 36.7 0.1 1.9 3.1 1.9 3 0-0.5-13.4-2.3-26.9-10.1-38.2-1-1.6-3.6-0.1-2.5 1.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1302.9 822.1c4.5-5.1 9.1-10.2 14.7-14.1 4.5-3.1 9.6-5 13.7-8.8 1.4-1.3-0.7-3.4-2.1-2.1-4.4 4.2-10.4 6.2-15.2 9.9-4.9 3.8-9 8.4-13.1 13-1.4 1.4 0.7 3.5 2 2.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1288.6 927.1c10.7-0.6 21.1 1.3 30.8 5.8 1.7 0.8 3.3-1.8 1.5-2.6-10.2-4.7-21.1-6.8-32.4-6.2-1.9 0.1-1.9 3.1 0.1 3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1286 937.7c1.7-3.2 3.3-6.4 5-9.7-0.9-0.4-1.8-0.8-2.7-1.2-1 2.9-2 5.7-3 8.6-0.6 1.7 1.8 2.5 2.7 1.2 2-2.9 4.1-5.7 6.1-8.6-0.9-0.4-1.8-0.8-2.7-1.2l-3 9c-0.6 1.6 1.9 2.6 2.7 1.2 1.7-2.8 3.3-5.5 5-8.3-0.9-0.3-1.9-0.5-2.8-0.8 0.1 2.4-0.2 4.5-0.8 6.8-0.5 1.7 1.8 2.5 2.7 1.2 1.3-1.8 2.6-3.6 4-5.4-0.9-0.4-1.8-0.8-2.7-1.2-0.7 2.3-1.3 4.6-2 6.9-0.3 1.2 0.8 2.1 1.8 1.8 1.7-0.4 2.7-0.9 3.7-2.3 0.7-0.9 0.4-2.6-1.1-2.6-3.9 0.2-7.6 0.8-11.3 2.2-1.5 0.5-1.4 3 0.4 2.9 6.6-0.2 12.8-1.9 19.1-3.7 1.9-0.6 1.1-3.2-0.8-2.9-4.5 0.6-8.9 0.7-13.4 0.2 0.1 1 0.3 2 0.4 2.9 2.3-0.8 12.1-4 14-1.3 0.3-0.7 0.6-1.5 0.9-2.2-4.9 0.9-9.3-0.2-13.4-3.1-0.3 0.9-0.5 1.9-0.8 2.8 1-0.1 10.3-0.9 9.7 1.3 0.6-0.3 1.2-0.7 1.8-1-3.8-0.7-7.3-1.8-10.9-3.1-0.1 1-0.3 2-0.4 2.9 2.8 0.2 5 0.8 7.6 1.9 0.1-0.9 0.2-1.8 0.4-2.7-2.6 0.4-4.7 0-7.1-0.9-0.3 1-0.5 1.9-0.8 2.9 4.2 1.2 8.2 1.5 12.5 1.1 1.6-0.2 2.2-2.5 0.4-2.9-1.2-0.2-2.4-0.6-3.5-1.2l-1.2 2.7c2.3 0.7 4.4 1.1 6.8 1 1.9 0 1.9-3 0-3-3.4 0-6.2-0.7-9.2-2.3-0.1 0.9-0.2 1.8-0.4 2.7 4.7-0.9 8.8 0.1 12.7 2.8 0.3-0.9 0.5-1.9 0.8-2.8-6.7-0.4-13.4-1-20-1.9v2.9c6.9-1.5 13.5-1.3 20.3 0.5 0.1-1 0.3-2 0.4-2.9-8.2 0.7-16.2 0-24.2-2v2.9c6.9-2.7 14.1-2.7 20.4 1.4 0.3-0.9 0.5-1.9 0.8-2.8-4.7 0.3-9.1-0.1-13.7-1.1-0.1 1-0.3 2-0.4 2.9 3.7 0.4 7.5 0.8 11.2 1.1 1.9 0.2 1.9-2.8 0-3-3.7-0.4-7.5-0.8-11.2-1.1-1.7-0.2-2 2.6-0.4 2.9 4.8 1.1 9.6 1.6 14.5 1.3 1.5-0.1 2-2 0.8-2.8-6.9-4.5-15.2-4.7-22.7-1.7-1.3 0.5-1.6 2.5 0 2.9 8.2 2.1 16.5 2.8 25 2.1 1.6-0.1 2.1-2.5 0.4-2.9-7.3-1.9-14.5-2.1-21.9-0.5-1.4 0.3-1.5 2.7 0 2.9 6.9 1 13.8 1.7 20.8 2 1.6 0.1 1.9-2 0.8-2.8-4.6-3.2-9.6-4.1-15-3.1-1.3 0.2-1.5 2.2-0.4 2.7 3.4 1.8 6.8 2.7 10.7 2.7v-3c-2.1 0-4-0.3-6-0.9-1.6-0.5-2.7 2-1.2 2.7 1.4 0.7 2.7 1.1 4.2 1.5 0.1-1 0.3-2 0.4-2.9-4 0.4-7.8 0.1-11.7-1-1.9-0.5-2.6 2.2-0.8 2.9 3 1.1 5.5 1.3 8.7 0.9 1.2-0.2 1.5-2.2 0.4-2.7-3-1.3-5.8-2.1-9.1-2.3-1.8-0.2-1.9 2.4-0.4 2.9 3.6 1.4 7.2 2.4 10.9 3.1 0.8 0.2 1.6-0.2 1.8-1 1.7-6.7-9-5.4-12.6-5.1-1.5 0.1-2 1.9-0.8 2.8 4.8 3.3 10 4.4 15.7 3.4 0.9-0.2 1.4-1.5 0.9-2.2-3.3-4.7-13-1.5-17.3-0.1-1.7 0.6-1.3 2.8 0.4 2.9 4.8 0.5 9.4 0.4 14.2-0.3-0.3-1-0.5-1.9-0.8-2.9-6 1.8-12 3.4-18.3 3.6 0.1 1 0.3 2 0.4 2.9 3.5-1.2 6.8-1.9 10.5-2.1-0.4-0.9-0.7-1.7-1.1-2.6l-2.4 1.5 1.8 1.8c0.7-2.3 1.3-4.6 2-6.9 0.5-1.7-1.8-2.5-2.7-1.2-1.3 1.8-2.6 3.6-4 5.4 0.9 0.4 1.8 0.8 2.7 1.2 0.7-2.6 1-4.9 0.9-7.6 0-1.5-2-2.1-2.8-0.8-1.7 2.8-3.3 5.5-5 8.3 0.9 0.4 1.8 0.8 2.7 1.2l3-9c0.6-1.7-1.8-2.5-2.7-1.2-2 2.9-4.1 5.7-6.1 8.6 0.9 0.4 1.8 0.8 2.7 1.2 1-2.9 2-5.7 3-8.6 0.6-1.6-2-2.7-2.7-1.2-1.7 3.2-3.3 6.4-5 9.7-0.7 2.1 1.9 3.6 2.8 1.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1206.4 930.8c-1.5-1.1-2.7-1.4-4.4-1.6-1.9-0.2-1.9 2.7 0 3 7.6 1 15.1 2 22.7 3v-3c-6.3-0.6-12.6-1.1-18.9-1.7v3c6.4 0 12.6 1 18.7 2.9 0.1-1 0.3-2 0.4-2.9-5.9 0.1-11.3-1.3-16.4-4.3-0.1 0.9-0.2 1.8-0.4 2.7 6.6-1.2 12.8 0.1 18.3 3.9 0.3-0.9 0.5-1.9 0.8-2.8-6.4 0.3-12.2-1.4-17.3-5.3-0.3 0.9-0.5 1.9-0.8 2.8 6 0.5 11.6 1.9 17 4.5l1.2-2.7c-0.9-0.3-1.9-0.7-2.8-1v2.9c0.4-0.1 0.7-0.1 1.1-0.2 1.5 0.2 2.4-1.3 1.5-2.5-2.5-3.2-6.8-2.3-9.7-4.8-0.5 0.8-1 1.7-1.5 2.5 5.9 0.9 10.7 3.6 14.5 8.3 0.4-0.9 0.7-1.7 1.1-2.6-2.2-0.2-3.9-0.6-6-1.3-1.7-0.5-2.6 1.9-1.2 2.7 2.3 1.4 4.4 2.3 7.1 2.7 1.9 0.3 2.7-2.3 0.8-2.9-2.1-0.6-4-1.5-5.9-2.6-0.5 0.9-1 1.7-1.5 2.6 2.4 1.1 4.7 1.8 7.3 2.2 1.9 0.3 2.7-2.6 0.8-2.9-2.4-0.3-4.3-0.8-6.6-1.9-1.7-0.8-3.2 1.6-1.5 2.6 2.1 1.2 4.2 2.1 6.6 2.9 0.3-1 0.5-1.9 0.8-2.9-2.3-0.4-4.3-1.1-6.4-2.4l-1.2 2.7c2.3 0.7 4.4 1.2 6.8 1.4 1.4 0.1 1.8-1.7 1.1-2.6-4.1-5-9.4-8.1-15.8-9-1.3-0.2-2.7 1.4-1.5 2.5 2.8 2.4 7.5 1.9 9.7 4.8 0.5-0.8 1-1.7 1.5-2.5-1.2-0.2-1.5-0.2-2.7 0.2-1.4 0.5-1.4 2.4 0 2.9 0.9 0.3 1.9 0.7 2.8 1 1.6 0.6 2.7-2 1.2-2.7-5.9-2.8-12-4.4-18.5-4.9-1.6-0.1-1.8 2-0.8 2.8 5.6 4.1 11.9 6 18.9 5.7 1.5-0.1 2-2 0.8-2.8-6.2-4.2-13.3-5.5-20.7-4.2-1.3 0.2-1.4 2.1-0.4 2.7 5.5 3.3 11.5 4.8 17.9 4.8 1.7 0 2-2.4 0.4-2.9-6.4-2-12.8-3-19.5-3-2 0-1.9 2.8 0 3 6.3 0.6 12.6 1.1 18.9 1.7 2 0.2 1.9-2.8 0-3-7.6-1-15.1-2-22.7-3v3c1 0.4 1.9 0.8 2.9 1.2 1.5 1 3-1.6 1.5-2.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1082.6 529.6v24.9c0 1.9 3 1.9 3 0v-24.9c0-1.9-3-1.9-3 0z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1085.4 558.6h242.4c1.9 0 1.9-3 0-3h-242.4c-2 0-2 3 0 3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1084.7 530.4h243.1c1.9 0 1.9-3 0-3h-243.1c-1.9 0-1.9 3 0 3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1326.9 530.9v24.2c0 1.9 3 1.9 3 0v-24.2c0-1.9-3-1.9-3 0z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1107.4 559c3.1 6.9 6.1 13.8 9.2 20.7 2.4 5.3 4.7 4.7 10.4 5 5.3 0.2 7.4 0.9 8.9-4.3 2.2-7.6 4.3-15.2 6.4-22.8 0.5-1.9-2.4-2.7-2.9-0.8-1.4 5.1-2.8 10.1-4.3 15.2-0.6 2.2-0.9 5.6-2.1 7.6 0.1 2-1 2.8-3.1 2.2-1.3-0.1-2.6-0.1-4-0.2-3.6-0.2-4.8-0.2-6.8-3.5-1.3-2.1-2.1-4.7-3.1-6.9-2-4.6-4.1-9.2-6.1-13.8-0.7-1.6-3.3-0.1-2.5 1.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1252.9 559.4c2.2 3.5 3.8 7.2 4.7 11.2 0.7 3.2 0.7 6.5 2.9 9.1 4.1 4.8 10.9 3.8 16.3 2.7 0.5-0.1 0.9-0.6 1-1l6-23.1c0.5-1.9-2.4-2.7-2.9-0.8-1.3 5.1-2.7 10.3-4 15.4-0.3 1.3-0.7 4.6-1.5 5.8-1.6 2.3-6.1 2.1-8.5 1.5-6.1-1.5-5.5-7.1-6.8-11.8-1-3.7-2.6-7.1-4.6-10.4-1.1-1.8-3.7-0.3-2.6 1.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1101.2 527.6v-115.9c0-1.9-3-1.9-3 0v115.9c0 1.9 3 1.9 3 0z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1100.5 412.2c5.9-2.4 11.9-2.4 17.8-0.2 1.8 0.7 2.6-2.2 0.8-2.9-6.3-2.4-13.1-2.4-19.4 0.2-1.7 0.7-1 3.6 0.8 2.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1118 412.6v113.6c0 1.9 3 1.9 3 0v-113.6c0-1.9-3-1.9-3 0z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1120.9 424.2c9-5.9 20.3-6.1 29.5-0.4 1.7 1 3.2-1.6 1.5-2.6-10.1-6.2-22.7-6-32.5 0.4-1.7 1.1-0.2 3.7 1.5 2.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1149.4 423.2v101.6c0 1.9 3 1.9 3 0v-101.6c0-1.9-3-1.9-3 0z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1103.1 423.7c0.3 2.8 0.6 5.5 0.9 8.3 0.2 1.9 3.2 1.9 3 0-0.3-2.8-0.6-5.5-0.9-8.3-0.2-1.9-3.2-1.9-3 0z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1106.2 432.6h6c1.9 0 1.9-3 0-3h-6c-2 0-2 3 0 3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1104.4 425.2 3.9 0.3c0.8 0.1 2.7-0.2 3 0.7 0.1 0.5-0.5 1.6-0.5 2.2 0 0.8 0.3 1.4 0.9 2 1.4 1.3 3.6-0.8 2.1-2.1 0 0 0.5-2.2 0.5-2.6-0.1-1-0.6-1.8-1.5-2.4-1-0.6-2.1-0.6-3.2-0.7l-5.1-0.3c-2.1-0.2-2.1 2.8-0.1 2.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1125.5 430.2c-0.2 5.2-0.1 10.5 0.2 15.7 0.1 1.9 3.1 1.9 3 0-0.4-5.2-0.5-10.5-0.2-15.7 0.1-2-2.9-2-3 0z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1126.5 430.9 18.9 0.9-1.5-1.5v13.8c0 1.9 3 1.9 3 0v-13.8c0-0.8-0.7-1.5-1.5-1.5l-18.9-0.9c-2-0.1-2 2.9 0 3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1126.9 448.9c5.2-0.2 10.5-0.4 15.7-0.6 1.9-0.1 1.9-3.1 0-3-5.2 0.2-10.5 0.4-15.7 0.6-1.9 0-1.9 3 0 3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1167.7 527.6v-14.8c0-1.9-3-1.9-3 0v14.8c0 1.9 3 1.9 3 0z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1165.7 512.9h90.5c1.9 0 1.9-3 0-3h-90.5c-1.9 0-1.9 3 0 3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1254.7 512.3v16.2c0 1.9 3 1.9 3 0v-16.2c0-1.9-3-1.9-3 0z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1191.2 510.5v-11.1c0-1.9-3-1.9-3 0v11.1c0 1.9 3 1.9 3 0z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1190.2 500.5h86.8c1.9 0 1.9-3 0-3h-86.8c-2 0-2 3 0 3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1256.7 514.3h18c1.9 0 1.9-3 0-3h-18c-2 0-2 3 0 3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1276.5 498.6c-0.7 4.7-1.1 9.5-1.1 14.2 0 1.9 3 1.9 3 0 0-4.5 0.3-9 1-13.4 0.3-1.9-2.6-2.7-2.9-0.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1211.2 444.4c0.6 18.3 3.1 36.4 7.5 54.2 0.5 1.9 3.4 1.1 2.9-0.8-4.3-17.5-6.8-35.4-7.4-53.4-0.1-2-3.1-2-3 0z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1213.4 445.5c6.3-2.5 12.8-3.1 19.5-3.7 6.9-0.7 12.3 0.6 18.8 2.8 1.8 0.6 2.6-2.3 0.8-2.9-6.9-2.3-12.2-3.6-19.6-2.9-7 0.7-13.7 1.2-20.3 3.8-1.8 0.7-1 3.6 0.8 2.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1250.7 444c0.7 17.9-1.8 35.6-7.3 52.6-0.6 1.8 2.3 2.6 2.9 0.8 5.6-17.3 8.1-35.3 7.4-53.4-0.1-1.9-3.1-1.9-3 0z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1219.7 441c-1.2-2.7-2.1-5.6-2.7-8.5-0.3-1.6-0.6-3.2-0.7-4.9-0.1-2.1-0.5-2.6 1.6-3.1 1.6-0.4 1.4-0.6 2.2 0.5 0.7 0.9 0.7 3.1 0.9 4.2 0.7 3.4 1.1 6.9 1.4 10.4 0.2 1.9 3.2 1.9 3 0-0.4-5.2-0.8-11.2-2.6-16.1-1.2-3.1-3.5-2.5-6.3-1.8-4 1-3.6 3.4-3.2 7.2 0.5 4.7 1.8 9.2 3.7 13.6 0.9 1.8 3.5 0.3 2.7-1.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1238.7 439c1.4-6.1 2.9-12.2 4.7-18.2 0.9-3 1.8-6 2.8-9 1.1-3.5 2.7-5.7 6.4-4.2 3.1 1.3 4.5 0.5 3.4 4.4-0.8 2.8-2.2 5.6-3.2 8.4l-7.5 19.5c-0.7 1.8 2.2 2.6 2.9 0.8 3.6-9.3 7.2-18.6 10.8-27.9 0.6-1.6 2.4-4.3 1.1-6-0.5-0.7-1.1-0.6-1.8-0.9-2.1-0.8-4.5-1.3-6.7-2.1-5.7-2-6.8 2.5-8.3 7.2-2.9 9-5.4 18-7.5 27.2-0.4 1.9 2.5 2.7 2.9 0.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1243.2 436.7c1.2 0.2 2.4 0.3 3.6 0.5 0.8 0.1 1.5-0.8 1.5-1.5 0-0.9-0.7-1.4-1.5-1.5-1.2-0.2-2.4-0.3-3.6-0.5-0.8-0.1-1.5 0.8-1.5 1.5 0 0.9 0.7 1.4 1.5 1.5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1245.3 427.9c1.2 0.3 2.4 0.7 3.7 1 1.9 0.5 2.7-2.4 0.8-2.9-1.2-0.3-2.4-0.7-3.7-1-1.8-0.5-2.6 2.4-0.8 2.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1248.6 419.8c1.3 0.4 2.7 0.8 4 1.2 1.8 0.6 2.6-2.3 0.8-2.9-1.3-0.4-2.7-0.8-4-1.2-1.8-0.6-2.6 2.3-0.8 2.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1250.9 411.8c1.1 0.5 2.1 0.9 3.2 1.4 0.7 0.3 1.6 0.2 2.1-0.5 0.4-0.6 0.2-1.7-0.5-2.1-1.1-0.5-2.1-0.9-3.2-1.4-0.7-0.3-1.6-0.2-2.1 0.5-0.4 0.7-0.3 1.8 0.5 2.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1166.8 112.4v235.4c0 1.9 3 1.9 3 0v-235.4c0-2-3-2-3 0z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1167.6 347.7v2.2c0 1.9 3 1.9 3 0v-21c0-1.9-3-1.9-3 0v21h3v-2.2c0-1.9-3-1.9-3 0z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1169.1 350.8h184.4c1.9 0 1.9-3 0-3h-184.4c-1.9 0-1.9 3 0 3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1354.2 350.1v-236.2c0-1.9-3-1.9-3 0v236.2c0 1.9 3 1.9 3 0z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1168.3 113.9h184.4c1.9 0 1.9-3 0-3h-184.4c-1.9 0-1.9 3 0 3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1176 119.8v218.4c0 1.9 3 1.9 3 0v-218.4c0-1.9-3-1.9-3 0z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1176.7 338.3v2c0 1.9 3 1.9 3 0v-19.5c0-1.9-3-1.9-3 0v19.5h3v-2c0-2-3-2-3 0z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1178.2 341.2h164.4c1.9 0 1.9-3 0-3h-164.4c-1.9 0-1.9 3 0 3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1343.4 340.4v-219.1c0-1.9-3-1.9-3 0v219.1c0 2 3 2 3 0z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1177.5 121.3h164.4c1.9 0 1.9-3 0-3h-164.4c-1.9 0-1.9 3 0 3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1179.8 192.9h158.1c1.9 0 1.9-3 0-3h-158.1c-1.9 0-1.9 3 0 3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1178.9 199.8h158.5c1.9 0 1.9-3 0-3h-158.5c-1.9 0-1.9 3 0 3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1199.5 188.6c-1.3-14.2-1.3-28.5 0-42.8 0.2-1.9-2.8-1.9-3 0-1.3 14.2-1.3 28.5 0 42.8 0.2 1.9 3.2 1.9 3 0z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1197.5 156.2c3.2-1 6.5-1.1 9.8-0.5 1.9 0.4 2.7-2.5 0.8-2.9-3.8-0.8-7.7-0.7-11.4 0.5-1.9 0.5-1.1 3.4 0.8 2.9z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1211.4 182.2c-1-5.2-1.9-10.5-2.1-15.9-0.1-2.4-0.1-4.8 0.1-7.2 0.2-2.1 0.4-7.7 1.8-9.3 2.8-3.1 3.2 4.1 3.4 6 0.3 2.5 0.4 5.1 0.5 7.7s0 5.1-0.1 7.7c-0.1 1.4-0.6 12.4-4.1 10.1-1.6-1.1-3.1 1.5-1.5 2.6 6.8 4.6 8.1-6.8 8.4-10.8 0.4-5.4 0.4-10.9-0.1-16.3-0.3-3.2-0.1-8.3-2.2-10.9-4.7-5.8-7.7 4.5-8.3 7.5-2 9.8-0.6 19.9 1.3 29.6 0.4 1.9 3.3 1.1 2.9-0.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1218.1 156c2.1-0.9 4.3-0.9 6.4-0.3 1.9 0.6 2.6-2.3 0.8-2.9-3-0.9-5.9-0.6-8.7 0.6-1.8 0.8-0.3 3.4 1.5 2.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1223.9 148.1c0.3 6.4 0.5 12.8 0.8 19.2 0.2 4.3-0.7 10.3 0.9 14.3 0.9 2.3 3.1 3.5 5.5 2.5 3.4-1.3 3.9-6 4.5-9 1-5.2 1.3-10.6 1-15.9-0.2-4.2-0.4-9.5-2.4-13.3-3.7-7.2-10.2-2.3-10.4 4-0.1 1.9 2.9 1.9 3 0 0.1-0.8 0.1-1.5 0.2-2.3 1.6 0.3 3.3 0.5 4.9 0.8 0.6 0.6 0.7 3.1 0.9 4 0.5 2.9 0.8 5.8 0.8 8.7 0.1 2.7 0 5.5-0.3 8.2-0.2 1.9-0.3 7.8-1.7 9.3 0 1-0.7 1.2-1.9 0.4-1.4 0.4-2 0-1.7-1.2-0.4-0.8-0.1-2.9-0.2-3.8-0.1-2.9-0.2-5.8-0.4-8.6-0.2-5.8-0.5-11.5-0.7-17.3 0.1-1.9-2.9-1.9-2.8 0z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1235.5 154.6c2.5-0.7 5-0.4 7.3 0.9 1.7 0.9 3.2-1.7 1.5-2.6-3-1.6-6.3-2-9.6-1.2-1.8 0.5-1.1 3.4 0.8 2.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1242.7 147.2 0.6 19.8c0.2 5-0.4 10.8 1 15.7 0.6 1.9 2.3 5.5 4.8 5 3.1-0.6 4-7.2 4.5-9.4 2.2-10.3 0.9-21.2-1.4-31.4-1.8-8.1-9-6-10 1.3-0.3 1.9 2.6 2.7 2.9 0.8-0.3-1.5 0.5-2.1 2.1-1.8 1.4-0.9 2.1-0.7 2.1 0.5 0.7 0.9 0.6 3.1 0.8 4.2 0.6 3.3 1.1 6.6 1.3 9.9 0.5 6.4 0.2 12.8-1.7 18.9-0.5 1.5-0.6 4-2.7 1.2-0.8-1-0.5-3.2-0.6-4.3-0.2-3.2-0.2-6.4-0.3-9.6-0.2-6.9-0.4-13.8-0.7-20.8 0.2-1.9-2.8-1.9-2.7 0z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1252.7 156c2.6-0.7 5.1-0.5 7.6 0.5 1.8 0.7 2.6-2.2 0.8-2.9-3-1.2-6.1-1.3-9.2-0.5-1.8 0.5-1 3.4 0.8 2.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1260.2 143.9c-0.8 14.9-0.9 29.7-0.5 44.6 0.1 1.9 3.1 1.9 3 0-0.4-14.9-0.3-29.8 0.5-44.6 0.1-1.9-2.9-1.9-3 0z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1209.4 155.5c1.6-0.9 3.4-0.9 5 0 1.7 1 3.2-1.6 1.5-2.6-2.5-1.4-5.5-1.5-8 0-1.7 0.9-0.2 3.5 1.5 2.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1227.4 155.3c1.7-1.3 4-1.4 5.7-0.1 1.5 1.2 3.6-0.9 2.1-2.1-2.7-2.2-6.5-2.5-9.3-0.4-1.5 1.2 0 3.8 1.5 2.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1246 155.2c1.5-0.9 3.4-0.7 4.8 0.5 1.4 1.3 3.5-0.8 2.1-2.1-2.3-2.1-5.7-2.6-8.4-1-1.7 1-0.2 3.6 1.5 2.6z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1310.9 142.7c0 8 1.8 17.7-3.1 24.5-4.7 6.5-9.2 12.9-13.2 19.9-0.9 1.7 1.6 3.2 2.6 1.5 2.4-4.3 5-8.6 7.9-12.7 2.3-3.3 5.2-6.4 7.1-9.9 3.6-6.6 1.7-16.2 1.7-23.4 0-1.8-3-1.8-3 0.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1313.2 143.9c3.4-1.2 6.9-1.1 10.2 0.2 1.8 0.7 2.6-2.2 0.8-2.9-3.8-1.5-8-1.5-11.8-0.2-1.8 0.6-1.1 3.5 0.8 2.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1321.8 143.2v20.3c0 1.9 3 1.9 3 0v-20.3c0-1.9-3-1.9-3 0z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1322.5 164.8c6.5 7.2 10.5 15.6 12.2 25.1 0.3 1.9 3.2 1.1 2.9-0.8-1.7-10-6.2-18.9-13-26.5-1.3-1.3-3.4 0.8-2.1 2.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1295.4 190.7c12.7 1.3 25.8 1.4 38.4-0.7 1.9-0.3 1.1-3.2-0.8-2.9-12.4 2-25.2 1.9-37.6 0.6-2-0.2-1.9 2.8 0 3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1313.3 186.4c1.6-0.5 3.2-0.6 4.8-0.1 1.9 0.5 2.7-2.4 0.8-2.9-2.1-0.6-4.3-0.6-6.4 0.1-1.8 0.6-1 3.5 0.8 2.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1314.7 180.7c1.3-0.2 2.7-0.1 4 0.3 1.9 0.5 2.7-2.4 0.8-2.9-1.8-0.5-3.7-0.6-5.6-0.3-0.8 0.1-1.2 1.1-1 1.8 0.2 0.9 1 1.2 1.8 1.1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1315.3 174.9c0.9 0.2 1.9 0.3 2.8 0.5 0.8 0.1 1.6-0.2 1.8-1 0.2-0.7-0.2-1.7-1-1.8-0.9-0.2-1.9-0.3-2.8-0.5-0.8-0.1-1.6 0.2-1.8 1-0.2 0.6 0.2 1.6 1 1.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1317.5 170.9c-0.1 0.2-0.3 0.3-0.5 0.4h-0.1c-0.1 0-0.2 0-0.4-0.1-0.3-0.4-0.4-0.5-0.3-0.2 0.4 0.7 1.4 0.9 2.1 0.5s0.9-1.3 0.5-2.1c-0.8-1.6-3.1-1.5-3.9-0.1-0.4 0.7-0.2 1.6 0.5 2.1s1.6 0.2 2.1-0.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1178.5 251.7h161.8c1.9 0 1.9-3 0-3h-161.8c-1.9 0-1.9 3 0 3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1179 259.1h161.3c1.9 0 1.9-3 0-3h-161.3c-1.9 0-1.9 3 0 3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1254.7 258.1v78.7c0 1.9 3 1.9 3 0v-78.7c0-2-3-2-3 0z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1264.7 300.9c-0.9-1.4-1.3-2.9-1-4.6 0.4-2.1 2.8-4.3 3.8-1.2 0.4 1.3 0.3 3.1 0.1 4.5-0.1 0.6-0.2 1.2-0.4 1.8-0.2 0.4-2 1.9-2 0.5 0.1-1.9-2.9-1.9-3 0-0.2 3.1 3.8 4.5 6.1 2.9 2.8-2 3-7.4 2.1-10.4-0.9-3.3-4.9-5.3-7.6-2.6-2.8 2.8-2.8 7.5-0.7 10.7 1.1 1.5 3.7 0 2.6-1.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1277.1 249.9c0-1 0-2-0.1-3 0-2-0.4-2.3 0.9-3.3 1.8-1.3 6.6-1 8.7-1.2 5.8-0.6 11.6-1 17.5-1.2 11.7-0.4 23.4 0 35 1 1.9 0.2 1.9-2.8 0-3-14.5-1.3-29.2-1.5-43.7-0.5-3.6 0.2-7.1 0.5-10.7 0.9-2.7 0.3-6.2 0.1-8.7 1.2-3.3 1.4-2 6.1-1.9 9.1 0 1.9 3 2 3 0z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1289.9 238.7c-1-5.9 6.6-4.5 10.4-4.6 4-0.1 8-0.1 12-0.2l24-0.3c1.9 0 1.9-3 0-3-12 0.2-24 0.3-35.9 0.5-7.3 0.1-14.9-1.2-13.3 8.4 0.2 1.9 3.1 1.1 2.8-0.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1275 222.5c0 3-1.1 7.8 2.6 9 4.4 1.4 10 1 14.6 0.7 1.9-0.1 1.9-3.1 0-3-3.3 0.2-6.5 0.2-9.8-0.1-1.7-0.2-3.9 0.1-4.4-1.7-0.4-1.4 0-3.5 0-4.9 0-1.9-3-1.9-3 0z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1276.5 223.9c20.2-1 40.5-1.1 60.7-0.2 1.9 0.1 1.9-2.9 0-3-20.2-0.9-40.5-0.8-60.7 0.2-1.9 0.1-1.9 3.1 0 3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m437.2 471h165.3c1.9 0 1.9-3 0-3h-165.3c-1.9 0-1.9 3 0 3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m482.2 470.8v57.4c0 1.9 3 1.9 3 0v-57.4c0-1.9-3-1.9-3 0z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m561.4 472.2v51.9c0 1.9 3 1.9 3 0v-51.9c0-1.9-3-1.9-3 0z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m522.1 466.7v-41c0-1.9-3-1.9-3 0v41c0 2 3 2 3 0z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m500.1 419.1h77.9c1.9 0 1.9-3 0-3h-77.9c-2 0-2 3 0 3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m721.2 176.5v81c0 1.9 3 1.9 3 0v-81c0-1.9-3-1.9-3 0z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m723.8 176.9h93.2c1.9 0 1.9-3 0-3h-93.2c-1.9 0-1.9 3 0 3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m726.1 260.1h88.8c1.9 0 1.9-3 0-3h-88.8c-2 0-2 3 0 3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m817.8 175.4v79.9c0 1.9 3 1.9 3 0v-79.9c0-1.9-3-1.9-3 0z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m732.1 187.1c-1.1 20.7-1.3 41.4-0.8 62.1 0 1.9 3 1.9 3 0-0.5-20.7-0.2-41.4 0.8-62.1 0.1-2-2.9-2-3 0z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m735.8 189c25-0.1 50.1-0.7 75.1-1.7 1.9-0.1 1.9-3.1 0-3-25 1-50 1.6-75.1 1.7-1.9 0-1.9 3 0 3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m809.2 187.1c0.8 20.5 0.5 40.9-0.7 61.4-0.1 1.9 2.9 1.9 3 0 1.3-20.4 1.5-40.9 0.7-61.4-0.1-2-3.1-2-3 0z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m735.2 252.4c12.8-1.4 25.7-3.1 38.5-4 6.3-0.4 12.7-0.6 19-0.2 6.3 0.5 12.5 1.7 18.8 0.9 1.9-0.2 1.9-3.2 0-3-6 0.8-11.9-0.4-17.9-0.9-6.6-0.5-13.3-0.4-20 0.1-12.9 0.9-25.7 2.6-38.5 4-1.8 0.3-1.8 3.3 0.1 3.1z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m732.8 231.3c6.1-0.1 12.2-0.1 18.2-0.4s11.8-2.9 17.8-2.6 11.8 1.4 17.8 1.3c6.6 0 13.2-0.6 19.8-1.2 1.9-0.2 1.9-3.2 0-3-6.3 0.5-12.5 1.1-18.8 1.2s-12.5-1-18.8-1.3c-5.8-0.3-11.2 2.1-17 2.5-6.3 0.4-12.7 0.3-19.1 0.4-1.8 0.1-1.8 3.1 0.1 3.1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m763.8 208.4c-1.5-1.5-1.6-2.7-0.2-3.8 0.5-0.5 1.1-1 1.7-1.4 1-0.6 2.2-1 3.3-1 2.5 0 4.9 1.7 5.4 4.2s-1.4 4.8-3.8 5.5c-2.6 0.8-5.3-0.5-7.2-2.2-1.4-1.3-3.6 0.8-2.1 2.1 3.7 3.4 9.5 4.8 13.6 1.1 3.6-3.3 3.3-8.7-0.4-11.8-4-3.3-10-1.9-13.1 2-1.3 1.6-2.2 3.9-1.4 5.9 0.8 2.1 3.1 3.1 5.1 2.3 1.7-0.8 0.9-3.7-0.9-2.9z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m768.8 173.7c-0.4-3.2-0.3-8.8 2.2-11.3 1.9-1.9 2.2 1.9 2.4 3.3 0.3 2.1 0.3 4.1 0.1 6.2-0.2 1.9 2.8 1.9 3 0 0.3-3 0.4-15.6-5.5-13.5-2.5 0.9-3.8 4.5-4.5 6.8-0.9 3.1-1 6.2-0.6 9.3 0.3 1.9 3.2 1.1 2.9-0.8z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m632.9 1007.5h221.5 222.5 124.7c1.9 0 1.9-3 0-3h-221.5-222.5-124.7c-2 0-2 3 0 3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1310.3 1006h226.6c1.9 0 1.9-3 0-3h-7.9c-1.9 0-1.9 3 0 3h7.9c1.9 0 1.9-3 0-3h-226.6c-1.9 0-1.9 3 0 3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1084.5 1086.1h211.6 59.9c1.9 0 1.9-3 0-3h-211.6-59.9c-1.9 0-1.9 3 0 3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1210.3 1130.4h234.4c1.9 0 1.9-3 0-3h-234.4c-2 0-2 3 0 3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m647.2 1051.8h217 61.7c1.9 0 1.9-3 0-3h-217-61.7c-2 0-2 3 0 3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m708.6 1118.9h241.5c1.9 0 1.9-3 0-3h-241.5c-1.9 0-1.9 3 0 3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m855.6 1030.6c32.8 40.1 65.4 80.4 97.6 120.9 1.2 1.5 3.3-0.6 2.1-2.1-32.2-40.6-64.7-80.9-97.6-120.9-1.2-1.5-3.3 0.6-2.1 2.1z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1190.9 1043.8c40.9 48.8 100.9 75.7 144.2 121.9 1.3 1.4 3.4-0.7 2.1-2.1-43.3-46.2-103.3-73.2-144.2-121.9-1.2-1.5-3.3 0.6-2.1 2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m321.8 759.4h208.9 59c1.9 0 1.9-3 0-3h-208.9-59c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m324.8 787.6v29.8c0 1.9 3 1.9 3 0v-29.8c0-1.9-3-1.9-3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m327.4 788h44.1c1.9 0 1.9-3 0-3h-44.1c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m379.2 788h17.6c1.9 0 1.9-3 0-3h-17.6c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m405.6 788h164.2c1.9 0 1.9-3 0-3h-164.2c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m331.8 832.1h211.6c1.9 0 1.9-3 0-3h-211.6c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m569.5 793.1v24.3c0 1.9 3 1.9 3 0v-24.3c0-1.9-3-1.9-3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m443.6 813c-6.9-1.5-6.6-12.9 1.3-11.7 2.9 0.4 5.8 2.8 5.1 6-0.7 3.5-5.1 6-8.3 4.3-1.7-0.9-3.2 1.7-1.5 2.6 4.6 2.4 10.4-0.2 12.4-5s-1.5-9.6-6.3-10.7-9.8 1.4-10.5 6.5c-0.7 4.8 2.3 9.9 7.2 10.9 1.7 0.4 2.5-2.5 0.6-2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m338 874.7v145.5c0 1.9 3 1.9 3 0v-145.5c0-1.9-3-1.9-3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m343.9 875.1h164.2c1.9 0 1.9-3 0-3h-164.2c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m521.4 874h28.7c1.9 0 1.9-3 0-3h-28.7c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m346.1 1028.3h216c1.9 0 1.9-3 0-3h-216c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m560.6 880.2v137.8c0 1.9 3 1.9 3 0v-137.8c0-1.9-3-1.9-3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m538.8 945.7c-4.3-2.3-1.4-9.6 3.5-7.1 5.6 2.8 0.8 9.9-4.3 7.8-1.8-0.7-2.6 2.2-0.8 2.9 3.7 1.5 8.3-0.4 10.1-4 1.8-3.7-0.3-7.9-3.9-9.5-3.5-1.6-7.5-0.3-9 3.3-1.4 3.3-0.3 7.5 3 9.3 1.6 0.8 3.1-1.8 1.4-2.7z",
    style: {
      fill: "#666666"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m296.1 762.3v241.8 67.9c0 1.9 3 1.9 3 0v-241.8-67.9c0-2-3-2-3 0z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m299.8 1077.9h237.5 67.9c1.9 0 1.9-3 0-3h-237.5-67.9c-1.9 0-1.9 3 0 3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m608.8 1072v-250.9-71c0-1.9-3-1.9-3 0v250.9 71c0 2 3 2 3 0z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m300.7 749.5c14.9-7.8 30.1-14.9 45.7-21.3 1.8-0.7 1-3.6-0.8-2.9-15.8 6.4-31.3 13.6-46.4 21.6-1.7 0.9-0.2 3.5 1.5 2.6z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m565.8 717.3c13.5 7.6 25.9 16.7 37.2 27.3 1.4 1.3 3.5-0.8 2.1-2.1-11.5-10.7-24.1-20-37.8-27.8-1.7-1-3.2 1.6-1.5 2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m544.4 715.9v-102c0-1.9-3-1.9-3 0v102c0 1.9 3 1.9 3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m544.2 694.6c4.7-3.6 7.6 20.4 7.7 22.3s3.1 1.9 3 0c-0.2-4.1-2.9-31.9-12.2-24.9-1.5 1.2 0 3.8 1.5 2.6z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m513.8 658c8.8 0.2 17.6 0.5 26.4 0.7 1.9 0.1 1.9-2.9 0-3-8.8-0.2-17.6-0.5-26.4-0.7-2-0.1-2 2.9 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m544.9 607v-7.1c0-1.9-3-1.9-3 0v7.1c0 2 3 2 3 0z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m475.2 661c5.6 4.9 14.1 4.6 19.3-0.7 1.3-1.4-0.8-3.5-2.1-2.1-4 4.1-10.6 4.5-15 0.7-1.5-1.3-3.7 0.8-2.2 2.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m494.5 659.6h46.7c1.9 0 1.9-3 0-3h-46.7c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m343.1 736c-2.2-3-1.9-4.2 0.8-3.8 0.6 0 1.3-0.1 1.9-0.1l5.7-0.3c3.3-0.2 8.4-1.2 11.6-0.2 2.3 0 2.3 1.6-0.1 4.8-1.1 0.3-2.3 0.4-3.5 0.3-1.8 0.1-3.6-0.1-5.4-0.1-1 0-12.5 0-12.5-0.5 0-1.9-3-1.9-3 0-0.1 3.1 2.9 3.3 5.4 3.3 5.8 0.1 12.1 0.9 17.8 0.2 4.9-0.6 10.3-7.1 4.1-10.4-3.5-1.9-8.9-0.7-12.6-0.6-4.2 0.2-10.7-0.7-14.5 1.2-2.3 1.2-3.4 3.8-2.2 6.2 1.3 2.9 4.4 3.3 7.2 2.7 2-0.2 1.2-3.1-0.7-2.7z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m339.6 733.4 3 3.9c0.7 0.9 2.5 1.1 2.7-0.4 0.1-0.7 0.2-1.2 0-1.9-0.1-0.3-0.1-0.5-0.3-0.8-0.6 1.1-0.3 2 0.8 2.7 0.6-0.7 1.1-1.5 1.7-2.2 0.3 0.6 0.6 1.1 0.9 1.7 0.9-0.4 1.7-0.7 2.6-1.1 0 0-0.1 0-0.1-0.1 0.8-0.2 1.7-0.4 2.5-0.7h0.6c0.9 0.1 1.8 0.2 2.7 0.4-0.1 0.1-0.3 0.2-0.4 0.3h2.6c0-0.5-0.1-0.9-0.1-1.4 0.8 0.2 1.7 0.4 2.5 0.7-0.3 0-0.5 0-0.8-0.1h2.1c-0.6-0.6-1.5 2.9-1.6 3.3l1.5-1.5c-0.4-0.6-0.7-1.2-1.1-1.9 1.1-1.6-1.5-3.1-2.6-1.5-2.2 3.1-0.2 6.8 3.7 6.4 0.9-0.1 1.4-0.6 1.5-1.5 0.2-1.8 1.9-2.8 1.1-4.8-0.5-1.1-1.7-1.9-2.9-1.9-3.2 0-3.6 3.7-1.8 5.6 0.5 0.5 1.6 0.6 2.1 0 1.6-2 2.8-6.5-1.2-6.8-3.1-0.2-3.4 3.3-3 5.5 0.2 1.1 1.8 1.5 2.5 0.7 1.9-2.4 1.9-4.7 0-7.1-0.3-0.4-1-0.5-1.5-0.4-3.6 1.2-5.1 4.9-3.2 8.3 0.5 0.9 2.1 1 2.6 0 1.1-2.3 2-6.9-2-7.1-3.3-0.2-3.5 3.8-3.1 6.1 0.2 1.2 2.2 1.5 2.7 0.4 1.2-2.5-0.1-6.4-3.6-5.8-3.2 0.6-3.4 4.4-1.7 6.4 0.7 0.8 2.3 0.4 2.5-0.7 0.5-2.4-1.2-5.6-4.2-4.5-2.6 0.9-2.5 4.3-0.8 5.9 1 0.9 2.5 0.3 2.6-1.1 0.2-3-2.5-6.6-5.7-4.3-2.4 1.7-1.4 4.6 1 5.6 1.2 0.5 2.5-1.2 1.7-2.2-1.1-1.4-3.2-5.6-5.7-4.3s0 3.3-0.3 5c0.9-0.1 1.8-0.2 2.7-0.4l-3-3.9c-0.7-1.5-3.4 0-2.2 1.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m352.5 736.4c1.4 1 3.4 0.7 4.6-0.4 0.6-0.5 0.6-1.6 0-2.1-0.6-0.6-1.5-0.6-2.1 0-0.1 0.1-0.3 0.1-0.4 0.1h-0.2c0.1 0 0.1 0 0 0-0.2-0.1-0.2-0.1-0.1 0-0.1 0-0.2-0.1-0.3-0.2-0.7-0.5-1.7-0.1-2.1 0.5-0.3 0.8 0 1.6 0.6 2.1z",
    style: {
      fill: "#666666"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m471.1 643.7c1.1 4.9 2.1 9.9 3.2 14.8 0.4 1.9 3.3 1.1 2.9-0.8-1.1-4.9-2.1-9.9-3.2-14.8-0.4-1.9-3.3-1.1-2.9 0.8z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m473.1 644.5c6.4 2.3 13.2 2.2 19.6-0.4 1.8-0.7 1-3.6-0.8-2.9-5.9 2.4-12 2.6-18 0.4-1.8-0.6-2.6 2.3-0.8 2.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m492.4 642.9c-0.8 4.6-1.7 9.2-2.5 13.8-0.3 1.9 2.6 2.7 2.9 0.8 0.8-4.6 1.7-9.2 2.5-13.8 0.3-1.9-2.5-2.7-2.9-0.8z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m470.9 666.5c-5.1 15.9-9.6 32-13.4 48.3-0.4 1.9 2.5 2.7 2.9 0.8 3.8-16.3 8.3-32.4 13.4-48.3 0.6-1.9-2.3-2.7-2.9-0.8z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m459.1 717.2c6.2 3.5 14.2 3.2 21.1 3 8.4-0.3 16.6-1.6 24.7-3.7 1.9-0.5 1.1-3.4-0.8-2.9-7.2 1.9-14.6 3.1-22.1 3.5-6.9 0.3-15.3 1-21.4-2.5-1.7-1-3.2 1.6-1.5 2.6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m492.8 666c3.5 7.2 6.4 14.6 8.8 22.2 1 3.2 9 23.5 3.5 24.8-1.9 0.4-1.1 3.3 0.8 2.9 9-2 2.7-15.1 1.1-20.4-3.1-10.6-6.8-21-11.6-31-0.9-1.8-3.5-0.2-2.6 1.5z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m468.4 710.8c8.2 1.8 16.3 1.7 24.4-0.3 1.9-0.5 1.1-3.4-0.8-2.9-7.6 1.9-15.2 2-22.9 0.3-1.8-0.4-2.6 2.5-0.7 2.9z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m474.4 704.5c4.6 1.4 9.3 1.6 14 0.6 1.9-0.4 1.1-3.3-0.8-2.9-4.2 0.9-8.3 0.7-12.4-0.6-1.9-0.5-2.7 2.4-0.8 2.9z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m474.2 698.1h9.3c1.9 0 1.9-3 0-3h-9.3c-1.9 0-1.9 3 0 3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m473.2 689.5c4 0.7 8 0.5 11.8-0.7 1.8-0.6 1-3.5-0.8-2.9-3.4 1.1-6.8 1.4-10.3 0.7-1.8-0.4-2.6 2.5-0.7 2.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 357.1,
    cy: 653.9,
    rx: 46.8,
    ry: 45
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m343.5 698.4c1.1 9.3 2.9 18.7 0.5 27.9-0.5 1.9 2.4 2.7 2.9 0.8 2.5-9.5 0.8-19.1-0.4-28.7-0.2-1.9-3.2-2-3 0z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m363.6 698.6c-1.3 5-2.1 10.1-2.6 15.2-0.5 4.7-1.3 9.3 0.2 13.9 0.6 1.8 3.5 1.1 2.9-0.8-1.3-4.2-0.5-8.7-0.1-13.1 0.5-4.9 1.3-9.7 2.5-14.5 0.5-1.8-2.4-2.6-2.9-0.7z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m349.9 608.5c0.8-10.6 1-21.3 0.8-31.9l-1.5 1.5c4-0.4 7.1-2.3 9.6-5.4 4-5 4-11.9 7.6-16.8 2.6-3.5 8.1-3.6 12-4.1 3.7-0.5 7.4-0.7 11.1-0.9 7.3-0.3 14.6-0.3 21.9-0.3 14.6-0.1 29.2-0.3 43.9-0.4 3.3 0 6.6-0.1 10-0.1 0.8 0 5.4-0.5 6-0.1 1.2 0.9 0.8 4.2 0.8 5.5 0 2.5-0.8 6.4 0.2 8.8 1.1 2.8 4 4 2.4 7.9-0.7 1.8 2.2 2.6 2.9 0.8 0.8-2 1.1-4 0.2-6.1-0.4-0.9-0.9-1.4-1.3-2.2-1.3-2.5-1.5-4.6-1.4-7.3 0.1-4.7 1.6-9.5-3.8-10.4-3.8-0.6-8.1 0.1-12 0.1-4 0-8 0.1-12 0.1-8.3 0.1-16.6 0.2-24.9 0.2-15.3 0.1-31-0.6-46.2 1.6-5.9 0.9-10.5 1.1-13.1 6.9-3.1 6.9-4.5 18.1-13.9 19.2-0.8 0.1-1.5 0.6-1.5 1.5 0.3 10.7 0 21.3-0.8 31.9-0.2 1.9 2.8 1.9 3 0z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m369 608.5c-0.2-4.5-0.3-8.9-0.2-13.4 0.1-3.4-0.1-7.1 1.9-10.1 0.7-1.1 1.8-1.9 2.6-3 3.5-4.9 4.5-10.9 3.3-16.8-0.5 0.6-1 1.3-1.4 1.9 30-2 60-4.1 90.1-6.1-0.5-0.4-1-0.7-1.4-1.1 0.5 2.3-0.8 4.6-0.5 7 0.3 2.8 2.8 5.5 1.2 8.6-0.9 1.7 1.7 3.2 2.6 1.5 1.4-2.5 1.1-4.5 0.3-7.1-1.3-3.8 0.2-7-0.6-10.7-0.1-0.6-0.8-1.1-1.4-1.1-30 2-60 4.1-90.1 6.1-1 0.1-1.7 0.9-1.4 1.9 0.9 4.3 0.4 8.8-1.8 12.7-1.4 2.4-4.2 4.1-5.3 6.6-1.2 2.7-0.7 6.9-0.8 9.8-0.1 4.5 0 8.9 0.2 13.4-0.2 1.8 2.8 1.8 2.7-0.1z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m475.8 574.6c1.2 0.4 3.5-0.1 4.2 1 0.4 0.6 0.4 1.6 0.5 2.3 0.2 1.2 0.4 2.3 0.5 3.5 0.2 1.9 3.2 1.9 3 0-0.2-2.4-0.3-5.6-1.7-7.7s-3.7-1.3-5.7-2c-1.8-0.6-2.6 2.3-0.8 2.9z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m464.5 575.1c-2.1 2.2-0.8 5.3 1.9 6.2 2.3 0.7 4.9-0.5 5.6 2.7 0.4 1.8-0.9 4.2 0.4 5.9 1.6 2.1 7.2 1.5 9.3 0.6 3.4-1.5 2.9-7.1 2.3-10-0.3-1.9-3.2-1.1-2.9 0.8 0.3 1.4 0.7 4.1-0.1 5.4s-2.4 1.3-3.9 1.3c-2.3 0.1-2.1-0.6-2.2-2.8-0.1-0.9 0.2-1.9 0-2.8-0.2-1.3-0.9-2.4-2.1-3-0.6-0.3-1.2-0.5-1.9-0.6-0.4-0.1-5.4-0.5-4.4-1.5 1.5-1.4-0.6-3.6-2-2.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m477.4 604.5c0-0.7 0.4-5.3 1.7-4.4 0.7 0.5 0.3 2 0.1 2.6 0 0.1-0.7 1.9-1.1 1.3-1-1.6-3.6-0.1-2.6 1.5 1.2 1.9 3.8 2 5.3 0.4 1.6-1.6 2.1-4.8 1.2-6.8s-3.5-3-5.3-1.5c-1.9 1.5-2.4 4.6-2.3 6.9 0.1 1.9 3.1 1.9 3 0z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m480.7 629.7c-0.5-0.7-0.3-1.3 0.1-2 0.2-0.3 0.5-0.6 0.7-1 0.3-0.2 0.3-0.3 0-0.3-0.3-0.1-0.3 0 0 0.2 0 0.3 0.4 0.8 0.5 1.1 0.1 0.4 0.2 0.9 0.1 1.3-0.1 0.6-0.6 1.3-1.3 1.1-1.9-0.5-2.7 2.4-0.8 2.9 2 0.5 3.9-0.6 4.7-2.4 0.8-1.9 0.3-4.7-1.2-6.3-1.6-1.7-3.6-0.7-4.8 0.9-1.3 1.7-2 4-0.7 5.8 1.2 1.8 3.8 0.3 2.7-1.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m474 644c5.3-0.1 10.6-0.3 15.9-0.6 1.9-0.1 1.9-3.1 0-3l-15.9 0.6c-1.9 0-1.9 3 0 3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m316 672.1c4.4-10.5 15.9 0.6 21.1 3.9 5 3.3 11 4.5 16.8 2.7 3.1-1 5.8-2.8 8.7-4.3 4.1-2.1 8.2-2.9 12.8-2.5 7.4 0.6 14.3 4.7 21.9 3 1.9-0.4 1.1-3.3-0.8-2.9-5.3 1.2-10.2-1.1-15.3-2.2-3.6-0.8-7.4-1.2-11.1-0.9-8.7 0.9-15 8.6-24 7.3-8.1-1.2-12.7-9-20.4-11-4.8-1.2-10.1 0.4-12.1 5.2-0.9 2 1.7 3.5 2.4 1.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m335.5 674.7c13.2 2.8 20.7-10.7 32.4-13.3 10.7-2.4 24.8 9.4 33.5-1.5 1.2-1.5-0.9-3.6-2.1-2.1-7.7 9.6-22.2-1.6-32.2 0.7-10.7 2.5-19 15.9-30.8 13.3-1.9-0.4-2.7 2.5-0.8 2.9z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m336.6 659.4c-0.9-0.8-1.3-2.2-0.5-3.2 0.7-1 2.3-1.3 3.3-0.6s1.2 2.2 0.6 3.2c-0.7 1-2.2 1.2-3.4 0.6-1.6-0.9-3.1 1.6-1.5 2.6 2.4 1.4 5.7 0.8 7.3-1.6 1.5-2.3 0.9-5.6-1.3-7.2s-5.5-1.2-7.3 0.9c-1.8 2.2-1.5 5.6 0.6 7.4 1.6 1.3 3.7-0.8 2.2-2.1z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m353.8 636.7c-0.4-1.1 0-2.4 1.2-2.8 1.3-0.5 2.6 0.6 3 1.8 1 3.2-4.1 4.7-4 1.4 0-1.9-3-1.9-3 0 0 3 2.8 5.5 5.8 4.9 2.9-0.6 4.9-3.7 4.3-6.6-0.6-2.8-3.5-5.1-6.4-4.4-2.8 0.7-4.8 3.9-3.7 6.6 0.6 1.7 3.5 0.9 2.8-0.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m375.1 715.3h54.8c1.9 0 1.9-3 0-3h-54.8c-1.9 0-1.9 3 0 3z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m516.2 710.1h11.3c1.9 0 1.9-3 0-3h-11.3c-2 0-2 3 0 3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m267 1080.9h241.2c1.9 0 1.9-3 0-3h-241.2c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m445.6 1095.7h182c1.9 0 1.9-3 0-3h-182c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m401.2 1119.5h44.4c1.9 0 1.9-3 0-3h-44.4c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m598 1157.1h193.4c1.9 0 1.9-3 0-3h-193.4c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m888.1 1140h166.1c1.9 0 1.9-3 0-3h-166.1c-2 0-2 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1017.7 1149.1h97.8c1.9 0 1.9-3 0-3h-97.8c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m784.6 1106.2h130c1.9 0 1.9-3 0-3h-130c-1.9 0-1.9 3 0 3z",
    style: {
      fill: "#666666"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m705.6 1154.5c1.3 17.2 85.2 24.9 129.1 26.8 123.8 5.2 268.3-21.6 267.7-45.7-0.6-24.3-149.3-49.2-285-23.6-42.8 8-112.9 26.5-111.8 42.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "leg_r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m832.8 1053.8c-2.5 21.6-4.9 43.2-7.4 64.9-41.8 26.7-77.3 34.8-98.8 37.6-20.2 2.7-22.9 0-23.6-1.5-4.9-9.8 39.4-41.7 78.9-67.8l16.2-51.6c11.6 6.1 23.2 12.2 34.7 18.4z",
    style: {
      fill: "#666666"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m825.3 622.2c-13.6 65.7-25.9 137.2-35.3 214-9.4 75.9-14.9 147.5-17.7 214 5.3 4.1 16.7 11.7 33.2 14.5 17.2 2.9 31-0.9 37.4-3.1 2.5-27.8 5.9-56.6 10.4-86.2 13.8-91.6 35.2-173.6 59.2-245.2 9.1-8 22.1-21.6 32.2-41.6 2.9-5.6 27.2-53.9 11.4-76.9-15.3-22.4-70.1-22.3-130.8 10.5z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m868.4 668.4c-5.2 40.5-10.3 81-15.3 121.5-11.4 92-22.5 184-33.1 276.1-4.8 0.8-15.2 1.9-27.2-2.5-10.4-3.9-17.1-10.1-20.4-13.6 2-54.3 6.2-112.5 13.6-174.1 9.9-82.8 24-158.7 39.9-226.8 14.2 6.4 28.4 12.9 42.5 19.4z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m802.2 858.7c19.5 10.8 40.9 1.5 44.2 0-1.4-65.1-2.8-130.2-4.2-195.4-6.2-4.8-12.5-9.6-18.7-14.4-9 30.3-17.4 65-23.8 103.6-5.7 34.4-8.7 66.3-10.2 95.1 2.7 3.6 6.8 7.8 12.7 11.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "leg_l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1005.3 1060.4c0.2 9.8 0.5 19.7 0.7 29.5-11.2 9.7-26.6 24.4-42.8 44.2-12.6 15.4-21.1 25.9-18.4 29.5 4 5.4 31.2-8 78.9-31.7 13.4-6.7 24.4-12.4 31.7-16.2-5.7-27-11.3-54.1-17-81.1-10.9 8.6-22 17.2-33.1 25.8z",
    style: {
      fill: "#666666"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m990.5 628.4c2.8 23.4 7 60.4 11.4 106 8.6 88.1 9.1 116.2 15.6 166.2 4.6 35.2 12.9 87.2 29.1 150.6-3.7 3.7-12 11-24.9 14.5-15.5 4.3-28.4 0.6-33.2-1-14.5-43.3-28.6-89.4-41.6-138.2-18.7-69.9-32.8-136.4-43.6-198.4l-23.9-23.9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m875.4 674.7c10.4 5.2 23.5 10.7 39.2 14.8 10.8 2.8 20.8 4.5 29.5 5.4 4 26.1 10 67.2 15.6 118.1 7.1 64.9 7.4 88.5 14.8 129.4 5.4 29.7 15.4 73.1 35.5 125 4.2-0.2 11-1 18.5-4.4 8.5-3.9 14.1-9.3 17-12.6-8-31.7-17.3-73.6-24.4-123.5-8-55.8-8-85-15.5-157.5-3.5-33.6-8.6-76.8-16.3-127.2-38 10.8-75.9 21.6-113.9 32.5z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m936.8 858c7.6 2.8 30.8 10.1 55.5 0 8.2-3.4 14.6-7.8 19.2-11.8-3.9-22.7-7.9-45.4-11.8-68-14.1-38.7-28.1-77.4-42.2-116.1l-20.7 195.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m864.3 339.3c-12.5 40.9-24.5 84.6-35.2 131.2-14.5 62.4-24.9 121.5-32.3 176.2 18.9 9.3 53.7 23.5 99.5 24.7 41 1.1 73.4-8.6 92.4-15.9 7.6-55.7 13-118.4 13.7-187 0.5-48.6-1.5-94.2-4.9-136.1-19-3.4-44.1-6.1-73.4-3.9-23.6 1.7-43.8 6.1-59.8 10.8z",
    style: {
      fill: "#37ec74"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m939.2 345.5c-19.3 108.1-38.5 216.1-57.8 324.2 14.3 1.8 34 2.7 57-0.8 20.4-3.2 37.1-8.9 49.4-14.2 3.7-23.8 6.8-48.6 9.2-74.6 6.9-75.5 5.9-144.8 0.8-206.1-7.5-15.1-15.1-30.2-22.6-45.2-9.5-0.3-19-0.6-28.5-0.8 0.2 0.2 4.1 4.6 2.5 10.1-1.1 4.1-5.2 7.2-10 7.4z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m956 356.4c-2.3 40.8-5.6 83-10.1 126.5-6.7 65.1-15.3 126.9-25.1 185.1 7.9-0.1 16.6-0.5 26-1.7 16.1-2 30.2-5.5 41.9-9.2 11.5-58.3 19.1-145.3-10.1-241.3-6.6-21.6-14.3-41.4-22.6-59.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gown"
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m950.1 328c4.1 56.9 6.1 104.6 7.1 139.5 2.1 69.8 4.7 167.4-5.3 291.4-3.3 40.1-7 73.1-9.8 95.1 15.1-2.1 39.5-7.3 65.7-22.2 28-15.9 45.6-35.6 55.1-48-5.6-34.9-12.4-80.5-18.7-134.2-5.1-44.1-12.4-107.3-16-190.1-1.6-37.4-2.8-85.4-1.8-141.3-9.2 1.8-18.4 3.6-27.5 5.3-6-1.6-15.7-3.3-27.5-1.8-9.1 1.3-16.4 4-21.3 6.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m893.2 341.4c-7 30.5-16.1 73.1-24.9 124.4-19.5 113.9-26 203.6-28.4 246.1-2.1 36.1-3.9 83.8-3.6 140.4-20.3-9.7-36.9-17.2-48-22.2-30.8-13.8-44.1-19-47.1-31.1-2-8.3 1.7-16.5 5.3-22.2 3-22.9 8.1-56.5 16.9-96.8 15.6-72.2 22.5-71.7 36.4-134.2 18-80.7 12.9-109.8 39.1-174.1 7.7-18.8 15.2-33.8 20.4-43.5 30.5-2.4 46.2-1.5 47.1 2.7 0.7 2.2-3.8 5.8-13.2 10.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m776.4 659.7c6.5 10.7 15.8 19.1 27.2 24.3 1.7 0.8 3.3-1.8 1.5-2.6-11-5-19.9-12.9-26.2-23.2-0.9-1.7-3.5-0.2-2.5 1.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m765 702.3c3.2 10.3 7.2 21.1 16.2 27.7 8.1 6 17.4 5.2 23.8-2.7 1.2-1.5-0.9-3.6-2.1-2.1-7.1 8.7-16.8 6.4-23.8-1.1-5.8-6.3-8.7-14.5-11.2-22.6-0.6-1.8-3.5-1.1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m982.7 682.9c9.4-0.4 17.2-5.6 25-10.4 7.9-5 15.6-10.3 21.6-17.5 1.2-1.5-0.9-3.6-2.1-2.1-5.5 6.6-12.4 11.6-19.6 16.1-7.6 4.8-15.6 10.5-24.9 10.9-1.9 0.1-1.9 3.1 0 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m990 722.3c19.4 10.8 38.9-4.1 47.5-21.3 0.9-1.7-1.7-3.2-2.6-1.5-7.8 15.7-25.4 30.3-43.3 20.3-1.7-1-3.2 1.6-1.6 2.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m961.7 804.8c-0.9-1.2-1.8-2.9-1.1-4.5 0.5-1.2 2-1.9 3.1-1.1s1.7 2.9 1.7 4.1c0 1-1.2 2.9-2.3 1.8-1.4-1.4-3.5 0.7-2.1 2.1 1.9 2 5.2 1.3 6.7-0.9 1.7-2.6 0.6-6.6-1.4-8.8-1.9-2.1-5.1-2-7.1 0-2.5 2.4-1.8 6.3 0.1 8.8 1 1.6 3.6 0.1 2.4-1.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m964.5 723.7c-1.6-1.8-1.2-5.8 1.5-6.4 3.5-0.8 2.9 7.9-0.4 5.8-1.6-1.1-3.1 1.5-1.5 2.6 2.7 1.8 6 0 6.9-2.8s0-6.7-2.7-8.2c-2.7-1.4-5.8 0.6-7 3.1-1.3 2.7-0.8 5.8 1.1 8 1.2 1.4 3.3-0.7 2.1-2.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m966.9 629.1c-2.5-1.4-1.1-9 1.7-9.7 4.4-1.1 5.2 11.3-1.5 8.9-1.8-0.6-2.6 2.3-0.8 2.9 8.7 3 12.3-12.1 4.2-14.6-7.1-2.3-10.8 11.9-5.1 15.1 1.7 0.9 3.2-1.7 1.5-2.6z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m967.6 548.4c-0.9-0.8-1.6-1.9-1.9-3.1-0.2-1.2 0-3.3 1.5-3.6 1.2-0.3 1.9 1 2.3 1.9 0.2 0.5 0.3 1 0.4 1.6 0 0.2 0 2.4-0.5 2-1.5-1.2-3.6 0.9-2.1 2.1 2.3 1.9 5.2 0.3 5.6-2.5 0.4-2.7-0.8-6.2-3.3-7.6-2.6-1.4-5.4 0.2-6.4 2.7-1.2 3-0.1 6.6 2.3 8.7 1.4 1.2 3.5-0.9 2.1-2.2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m966.1 474.1c-0.6-1.5-1.3-3.4-0.7-5.1 0.6-1.5 2.4-2.5 3.5-0.9 0.7 1.1 0.8 2.7 0.8 3.9 0 1-1 4.1-2.4 2.5-1.3-1.5-3.4 0.7-2.1 2.1 1.8 2 5.1 1.4 6.5-0.7 1.7-2.5 1.3-6.8-0.2-9.3s-4.7-3-7-1.2c-3 2.4-2.5 6.3-1.3 9.5 0.6 1.8 3.5 1 2.9-0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m963.8 406.8c-0.1-1.2-0.4-3 0.5-4 1.2-1.2 2.2 0.6 2.7 1.5 0.5 1.1 0.9 2.4 0.4 3.5-0.5 1-2.5 1.8-2.5 0 0.1-1.9-2.9-1.9-3 0-0.1 2.7 2.7 4.7 5.3 3.9 2.9-0.9 3.9-4.2 3.2-6.9-0.6-2.5-2.7-6-5.7-5.5-3.6 0.6-4.1 4.4-3.8 7.4 0 2 3 2 2.9 0.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m998.9 325.3c3.4 0.6 6.5 1.9 9.2 4.1 1.5 1.2 3.6-0.9 2.1-2.1-3.1-2.5-6.6-4.2-10.5-4.9-1.9-0.3-2.7 2.6-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m771.6 673.5c5 10.8 14.1 18.7 25.4 22.3 1.8 0.6 2.6-2.3 0.8-2.9-10.6-3.4-18.9-10.9-23.6-21-0.9-1.7-3.4-0.2-2.6 1.6z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m984.4 692.6c17.4 2.8 36-9.2 46.8-22.1 1.2-1.5-0.9-3.6-2.1-2.1-10 11.9-27.6 23.9-43.8 21.3-2-0.3-2.8 2.6-0.9 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m981.8 689.4c1.3 7.3 2.8 14.6 4.7 21.8 1 3.8 1.6 11.3 5.9 13.1 1.8 0.7 3.3-1.8 1.5-2.6-2.5-1.1-3.1-6.4-3.7-8.6-0.8-2.7-1.5-5.4-2.1-8.1-1.3-5.4-2.4-10.9-3.4-16.4-0.3-1.9-3.2-1.1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m796.8 695.2c3 9.9 4.7 19.9 4.9 30.3 0 1.9 3 1.9 3 0-0.2-10.6-1.9-20.9-5-31.1-0.6-1.8-3.5-1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1002.9 409.5c5.7 43 9.9 89.7 11.3 139.7 3.1 110.5-7.9 208.3-23.3 289.2 10-3.9 22.4-9.8 35.5-18.9 16.7-11.6 28.5-24.2 36.2-34-5.3-42-14.5-115.1-24.2-197.8-2.6-22.5-6.3-54.2-9.1-96.6-1.8-27-2.6-49.5-3-64.9-7.8-5.6-15.6-11.2-23.4-16.7z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m845.1 434.4c-8.1 35-13.6 64.5-17.4 86.1-18 104.4-30.1 167-22.7 244.6 3.1 32.3 8.5 58.6 12.8 76.3-13.7-4.8-28.8-11-44.5-18.9-10.4-5.2-20-10.5-28.7-15.9-1.1-1.4-4.5-5.7-4.5-12.1-0.1-9.6 7.5-15.3 8.3-15.9 3.7-46 10.9-82.3 16.6-106.5 13.9-59 28.7-86.8 40.8-150.2 5.9-31.3 8.6-57.1 9.8-73.2 9.8-4.7 19.7-9.5 29.5-14.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m1047.4 701.7c-2.4 0.1-1.8 19.8-6 46.1-5.1 32-14.8 57.4-22.7 74.7 6.7-3.7 14.9-9 23.4-16.6 8.3-7.5 14.5-15 18.9-21.1-7.6-68.1-11.5-83.2-13.6-83.1z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m781.7 617.1c0.9 0.2-25.8 63.2-14.3 133.6 5.7 35 19.4 62.6 31 81.5-15.4-6.5-27.2-11.3-34.7-14.3-10.9-4.3-17.6-6.9-20.4-13.6-2.3-5.6-1.3-12.4-0.8-15.9 0.8-5.2 2.5-9.4 3.8-12.1 4.3-24.8 10.9-59.9 20.4-101.9 10.6-47.6 14.6-57.3 15-57.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand_r"
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m656 185.5c-1.8 14.5-3.6 28.9-5.4 43.4-14.9 34.1-29.7 68.2-44.6 102.3 8.3 4.2 24 10.8 44.6 11.3 24.8 0.6 43.3-7.9 51.7-12.5l-27.9-98.7c-0.2-15.3-0.4-30.5-0.6-45.8h-17.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m656.8 194.3c5.6 1.9 11.5 1.4 16.6-1.6 1.7-1 0.2-3.5-1.5-2.6-4.5 2.6-9.5 3-14.3 1.3-1.9-0.7-2.6 2.2-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m639.7 328.3c8.1 3.2 16.5 4 25.1 2.6 1.9-0.3 1.1-3.2-0.8-2.9-8.1 1.3-15.9 0.4-23.5-2.6-1.8-0.7-2.6 2.2-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m643.1 320.2c7.6 2.3 15.3 2.2 22.8 0 1.8-0.6 1.1-3.5-0.8-2.9-7.1 2.1-14.1 2.1-21.2 0-1.8-0.6-2.6 2.3-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m644.9 310.7c6.9 1.7 13.7 1.5 20.5-0.5 1.8-0.5 1.1-3.4-0.8-2.9-6.3 1.9-12.5 2-18.9 0.5-1.9-0.5-2.7 2.4-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m647.9 300.4c6.6 1.6 13.2 1.5 19.8-0.5 1.8-0.5 1.1-3.4-0.8-2.9-6 1.8-12.1 2-18.2 0.5-1.8-0.5-2.6 2.4-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m653.9 291.5c4.8 1 9.6 1 14.5 0.2 1.9-0.3 1.1-3.2-0.8-2.9-4.3 0.8-8.6 0.7-12.9-0.2-1.9-0.4-2.7 2.5-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m655.1 281.3c4.9 0.9 9.7 0.8 14.5-0.3 1.9-0.5 1.1-3.3-0.8-2.9-4.3 1-8.5 1.2-12.9 0.3-1.9-0.3-2.7 2.6-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m654.5 267.8c4.6 1.5 9.2 1.6 13.9 0.6 1.9-0.4 1.1-3.3-0.8-2.9-4.2 0.9-8.2 0.7-12.3-0.6-1.9-0.6-2.7 2.3-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m656.8 256.7c3.3 0.8 6.6 1.2 10 1 1.9-0.1 1.9-3.1 0-3-3.1 0.1-6.1-0.2-9.2-0.9-1.9-0.4-2.7 2.5-0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m680.8 268.5c-0.6-0.5-13-10.4-10.9-14.4 1.5-2.9 10.1-1.6 15.2 0 11.9 3.8 18.3 13.6 20.3 16.8 6.2 9.8 6.6 19.2 6.6 21.4 0.2 8.5-2.3 15-3.9 18.3 3.4 13.4 6.8 26.8 10.1 40.1-9.2 4.8-18.4 9.6-27.7 14.4-4-8.6-8.1-17.1-12.1-25.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m684.8 282.5c-1.7 8.4-1.4 16.7 0.7 25 0.5 1.9 3.4 1.1 2.9-0.8-2-7.8-2.3-15.5-0.7-23.4 0.3-1.9-2.6-2.7-2.9-0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m684.6 304.1c2.9 8.9 5.7 17.7 8.6 26.6 0.6 1.8 3.5 1 2.9-0.8-2.9-8.9-5.7-17.7-8.6-26.6-0.6-1.8-3.5-1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m676.5 341.7c7.4-1.4 14-4.9 19.4-10.1 1.4-1.3-0.7-3.5-2.1-2.1-5.1 4.9-11.1 8-18 9.3-2 0.4-1.2 3.3 0.7 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m679.1 268.3c1.9 6.8 5.4 12.8 10.3 17.9 1.3 1.4 3.5-0.7 2.1-2.1-4.5-4.7-7.7-10.3-9.5-16.6-0.6-1.8-3.5-1.1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m624.3 265.7c-2.2-0.8-8.2 5.6-7.5 12 0.4 4.3 3.6 7 5.2 8.4 3 2.6 8.1 5.2 9.5 3.9 1-1 0.5-4.2-6.1-14.3 0.8-7.6-0.1-9.6-1.1-10z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m623.9 257.7c-3.4 2.7-2.9 8.2-2.7 10 0.1 1.5 0.7 7 5.2 10.9 3.7 3.1 9.4 4.6 10.7 2.9 0.7-0.9 0-2.4-1.1-5-1.6-3.7-3.6-6.3-5-7.9 0-6.8-1.7-11.6-4.1-12-1.2-0.3-2.4 0.6-3 1.1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m625.5 256c-2.3 9.6 12 19.8 15.4 17.9 2-1.1 1.3-7.2 0.2-10.7-0.7-2.2-1.7-3.9-2.5-5 2-4.6 3.8-10.1 1.8-11.8-2.7-2.2-13.2 2.4-14.9 9.6z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m622.5 293.4c-5.9-0.3-15.8-0.4-16.6 2.5-0.6 2.3 4.6 6.2 5.7 7 1.9 1.5 3.8 2.4 5.2 2.9 1.9-4.1 3.8-8.2 5.7-12.4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m671.9 253.8c-1.6 3.8 23 10.5 28.1 29.5 2 7.3-0.8 9.9-1.5 27-0.5 11.5 0.3 21 1.1 27.4 4.4-2.7 8.8-5.3 13.1-8-1.7-6.6-3.4-13.1-5.1-19.7 1.9-4.4 5.1-13.4 3.3-24.4-0.4-2.5-3.7-20.5-19.7-28.8-8.1-4.3-18.3-5.4-19.3-3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m658.4 189.2c3.2 2.1 6.3 4.1 9.5 6.2 1.4 16.6 1.6 41.5-5.8 70.4-8.7 33.9-24 58.5-34.7 73 9.3 2.9 28.4 7.4 50 0.7 6.8-2.1 12.5-4.9 17.1-7.7-3-5.6-7-14.7-8.4-26.6-1.1-9.2-0.3-17.1 0.7-22.6-2-3.3-3.3-6.1-4-8-1.6-4.3-1.5-5.8-3.3-8-2.1-2.6-3.3-2-5.8-4.7-0.6-0.6-4.5-5-3.3-7.7 1.3-2.9 7.1-0.9 9.5-3.6 1.8-2.1 1.6-7-5.5-18.6l-1.5-44.1c-4.8 0.4-9.6 0.8-14.5 1.3z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m678.1 266.9c1.4 7.4 3.4 23.4-2.9 41.9-5.5 16.2-14.8 26.9-20.1 32.1 4.2 0.7 13 1.7 23-1.8 7.3-2.6 12.4-6.5 15.3-9.1-2.3-5.4-4.7-12.4-6.2-20.8-1.9-11-1.6-20.5-0.7-27.4-1.3-1.8-2.7-3.9-4-6.2-1.8-3-3.3-6-4.4-8.7z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m640.8 246.2c-1.2-0.5-8.6 7.6-6.8 15.9 1.2 5.7 6.6 10.1 7.9 9.3 0.8-0.5 0.6-3.4-3.7-13.6 3-9 3.1-11.3 2.6-11.6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m624.1 258.4c-1.1 0.4-0.1 9.3 5.4 16.1 2.9 3.7 7 6.5 7.6 5.9 0.5-0.4-0.7-2.3-5.7-10.5-6.5-10.8-7-11.6-7.3-11.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m620.3 300.1c-4.3 10.2-8.6 20.4-13 30.6 3.4 1.6 8 3.5 13.7 5.4 16.7 5.3 30.3 5.4 34.4 5.4 10.6-0.1 20.5-0.4 30.8-6.5 3.1-1.9 5.5-3.8 7-5.1-3.3-10.8-6.5-19.4-9-25.6-1.2-3-2.3-5.5-4.5-6.1-5.3-1.4-8.8 10.1-16.9 10.9-8 0.7-11.6-9.8-19.2-8.3-5.6 1.1-7.3 7.9-10.9 7-3.2-0.8-3.3-6.6-7.7-8-1.8-0.6-3.6-0.2-4.7 0.3z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m625.4 296.7c2.4-0.9 4.7-0.7 5.9-0.6 3.7 0.5 6.4 1.9 7 2.3 9.1 5 32.4-10.9 42.6-3.7 3.4 2.4 5 7 4.4 10.6-1.9 9.8-22.6 13.9-37 13.3-12.8-0.6-29.4-5.4-30.1-12.3-0.3-3.5 3.2-8.1 7.2-9.6z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m647.7 277.8c0 0.3-0.1 0.6-0.4 0.8-0.2 0.1-0.3 0.1-0.1 0.1h-0.2c0.3 0-0.3-0.1 0 0-0.3-0.1-0.5-0.3-0.6-0.6-0.1-0.4 0-0.7 0.2-0.9-0.1 0.1 0.4-0.2 0.3-0.2h0.2c-0.1 0-0.1 0 0 0s0.2 0 0.3 0.1c0.3 0.4 0.4 0.5 0.3 0.3-0.4-0.7-1.4-0.9-2.1-0.5s-0.9 1.3-0.5 2.1c1.2 2.2 5 0.8 4.2-1.7-0.3-1-1.3-1.6-2.3-1.6-1.2 0.1-2 0.9-2.2 2.1-0.1 0.8 0.8 1.5 1.5 1.5 0.8 0 1.3-0.6 1.4-1.5z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m654.7 252.2v-0.2c0 0.4-0.3 0.7-0.7 0.8h-0.8c-0.1 0-0.2-0.1-0.2-0.1l-0.5-0.5c0.1 0.1 0.1 0.1 0-0.2-0.1-0.2-0.1-0.4 0-0.6s0.3-0.4 0.4-0.7c0.2-0.1 0.4-0.3 0.7-0.4h0.8-0.1c-0.7-0.2-1.7 0.3-1.8 1-0.2 0.8 0.3 1.6 1 1.8 0.8 0.3 1.8-0.3 2-1.1 0.2-0.7-0.1-1.4-0.6-1.9-0.7-0.5-1.6-0.5-2.2 0.1-0.5 0.5-0.7 1.2-0.6 1.8 0.1 0.8 0.6 1.5 1.5 1.5 0.4 0.2 1.2-0.5 1.1-1.3z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m663.7 235.4v0.2c1-0.1 2-0.3 2.9-0.4-0.1-0.3-0.1-0.1 0 0.4 0 0.1-0.1 0.2-0.2 0.3-0.2 0.1-0.2 0.1 0 0 0 0-0.1 0-0.1 0.1-0.5 0-0.8 0-1-0.5v-0.1 0 0c0-0.1 0.1-0.2 0.2-0.3 0.2-0.2 0.3-0.1 0.5-0.2 0.1 0 0.1 0 0 0 0.1 0 0.2 0.1 0.2 0.2-0.1-0.1-0.1-0.1 0 0 0.1 0.2 0.1 0.2 0 0-0.1 0.4-0.1 0.8-0.2 1.2-0.1 0.3-0.7 0.4-0.9 0.3-0.5-0.2-0.8-0.7-0.6-1.2l2.4-0.3c-0.2-0.2-0.5-0.4-0.7-0.6-0.6-0.5-1.5-0.6-2.1 0s-0.6 1.6 0 2.1c0.2 0.2 0.5 0.4 0.7 0.6 0.7 0.6 1.9 0.6 2.4-0.3 0.5-1 0.3-2.3-0.7-2.9-0.9-0.6-2.1-0.4-2.8 0.4-0.8 0.9-0.5 2.1 0.3 2.8 0.7 0.6 1.7 0.9 2.6 0.6 1.7-0.5 2.2-3 0.9-4.2-0.8-0.7-1.9-0.7-2.8-0.1-0.8 0.6-1.3 1.6-0.9 2.6 0.3 0.7 0.9 1.2 1.6 1.1s1.4-0.7 1.3-1.5v-0.2c-0.1-0.8-0.6-1.5-1.5-1.5-0.7-0.1-1.5 0.6-1.5 1.4z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m661.9 212.6c-0.2-0.3 0.1 0.3 0 0.4 0 0.1-0.2 0.3 0 0.1-0.2 0.2-0.5 0.4-0.8 0.3l-1-1c0.1 0.2 0 0 0-0.1 0-0.2 0.1-0.3 0.3-0.5h1.5c0.3 0.2 0.4 0.4 0.4 0.7v0.1 0c-0.1 0.1 0 0.1 0 0 0 0.1-0.1 0.2-0.2 0.2-0.1 0.1-0.6 0.2-0.4 0.2-0.4-0.2-0.9-0.5-1.3-0.7 0.1 0.2 0-0.1 0-0.2v0 0s0-0.1 0.1-0.1c-0.1 0.1-0.1 0.1 0 0 0.2-0.2 0 0-0.1 0 0.7 0.2 1.4 0.4 2.1 0.5-0.4-0.5-0.7-1-1.1-1.5-0.5-0.6-1.3-1-2.1-0.5-0.6 0.4-1 1.4-0.5 2.1 0.4 0.5 0.7 1 1.1 1.5 0.5 0.7 1.2 0.9 2.1 0.5s1.4-1.4 1.5-2.3c0.1-1.3-0.7-2.5-2.1-2.3-0.9 0.1-1.7 0.8-1.9 1.8-0.3 1 0.1 2 1 2.6 0.4 0.3 1.1 0.3 1.5 0 0.7-0.5 1.2-1.3 1.2-2.2-0.1-1.1-0.9-1.9-2.1-1.8-1.6 0.2-2.7 2.2-1.7 3.6 0.5 0.7 1.3 1 2.1 0.5 0.5-0.2 0.9-1.2 0.4-1.9z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m662.9 167.7c-0.3 0.6-1.2 0.4-1.5 0-0.1-0.4-0.1-0.8-0.2-1.2 0 0.1 0 0.2-0.1 0.3v0.1 0s-0.2 0.3-0.1 0.2l-0.2 0.2h2.1c0.1 0.2 0 0 0 0v0.1-0.1 0c0 0.2 0.1-0.2 0.1-0.2-0.5 0.4-1 0.7-1.4 1.1-0.7-0.1-0.9-0.5-0.7-1.3 0.2-0.3 0.6-0.5 0.9-0.4-0.8-0.2-1.7 0.2-1.8 1-0.2 0.7 0.2 1.7 1 1.8 1.2 0.2 2.4-0.4 2.7-1.6 0.3-1.4-0.8-2.6-2.1-2.6-0.7 0-1.2 0.5-1.4 1.1-0.4 1.1-0.1 2.3 0.7 3.2 0.5 0.6 1.6 0.5 2.1 0 0.9-0.9 1.8-2.6 0.7-3.7-0.9-0.9-2.7-0.8-3.3 0.5-0.3 0.7-0.2 1.6 0.5 2.1 0.6 0.3 1.7 0.2 2-0.6z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m643.8 163.3c-0.1 0-0.1 0 0 0 0.1-0.1 0.2-0.4 0.4-0.6l-0.1 0.1c0.2-0.1 0.4-0.3 0.7-0.4 0.3 0 0.5 0.1 0.8 0.1l0.5 0.5c0 0.3 0 0.5 0.1 0.8-0.3 0.2-0.6 0.5-0.9 0.7 0.3-0.1 0 0-0.2-0.1l-0.5-0.5c-0.5-0.7 1-1.4 1.3-0.5-0.2-0.8-1.1-1.3-1.8-1-0.8 0.2-1.3 1.1-1 1.8 0.4 1.3 1.9 2.1 3.2 1.6 1.3-0.6 1.9-2.4 0.9-3.5-0.5-0.6-1.5-0.8-2.3-0.6-0.9 0.2-1.5 1.1-1.5 2 0.1 2 2.9 2.5 3.5 0.6 0.2-0.8-0.3-1.7-1-1.8-1.1-0.5-1.9 0-2.1 0.8z",
    style: {
      fill: "#5f2dc2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m663.1 138.6c0.1 0 0.1 0.1 0.2 0.1 0.1 0.2 0.3 0.4 0.4 0.7-0.2-0.4-0.2-0.1-0.3 1-0.2 0.1-0.4 0.3-0.7 0.4l-1.4-1.4c0.1-0.2 0.3-0.4 0.4-0.7l-0.1 0.1c-0.5 0.6-0.6 1.5 0 2.1 0.5 0.5 1.6 0.6 2.1 0s0.7-1.4 0.3-2.2c-0.4-0.7-1.1-1.1-1.8-1-1.7 0.2-2 2.6-0.6 3.4 0.7 0.4 1.6 0.2 2.1-0.5 0.3-0.7 0.1-1.6-0.6-2z",
    style: {
      fill: "#5f2dc2",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m678.4 165.6c-0.1 0.7-0.3 1.5-0.4 2.2-0.2 0.9 1.3 1.3 1.4 0.4 0.1-0.7 0.3-1.5 0.4-2.2 0.2-0.9-1.2-1.3-1.4-0.4z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m681.2 166 1.5 1.5c0.7 0.7 1.8-0.4 1.1-1.1l-1.5-1.5c-0.7-0.7-1.8 0.4-1.1 1.1z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m676.8 164.1c-0.6 0.1-1.2 0.3-1.8 0.4-0.9 0.2-0.5 1.6 0.4 1.4 0.6-0.1 1.2-0.3 1.8-0.4 0.9-0.2 0.5-1.7-0.4-1.4z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m678 161.4c-0.2-0.4-0.5-0.7-0.7-1.1-0.5-0.8-1.8 0-1.3 0.8 0.2 0.4 0.5 0.7 0.7 1.1 0.5 0.8 1.8 0.1 1.3-0.8z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m681.9 160.3c0.4-0.6 0.8-1.2 1.1-1.8 0.5-0.8-0.8-1.6-1.3-0.8-0.4 0.6-0.8 1.2-1.1 1.8-0.5 0.9 0.8 1.6 1.3 0.8z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m684.8 161.4c0.6-0.1 1.2-0.3 1.8-0.4 0.9-0.2 0.5-1.6-0.4-1.4-0.6 0.1-1.2 0.3-1.8 0.4-0.9 0.2-0.5 1.6 0.4 1.4z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m642.3 138.4c-0.3 0.6-0.6 0.9-1.2 1.2-0.4 0.2-0.5 0.7-0.3 1 0.2 0.4 0.7 0.4 1 0.3 0.8-0.3 1.4-1 1.7-1.7 0.2-0.4 0.1-0.8-0.3-1-0.2-0.3-0.8-0.2-0.9 0.2z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m644.1 139.9c0.5 0.7 0.8 1.5 1 2.4 0.2 1 1.6 0.5 1.4-0.4-0.2-1-0.6-1.9-1.1-2.8-0.6-0.8-1.9 0-1.3 0.8z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m639.5 137.9c0.5-0.6 1.1-0.9 1.8-1 0.4-0.1 0.6-0.6 0.5-0.9-0.1-0.4-0.5-0.6-0.9-0.5-1 0.1-1.8 0.6-2.5 1.3s0.4 1.8 1.1 1.1z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m640.6 132.3 1.1 1.1c0.7 0.7 1.7-0.4 1.1-1.1l-1.1-1.1c-0.8-0.6-1.8 0.5-1.1 1.1z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m645.8 133.7c0.4-0.6 0.7-1.2 1.1-1.8 0.5-0.8-0.8-1.6-1.3-0.8-0.4 0.6-0.7 1.2-1.1 1.8-0.5 0.8 0.8 1.6 1.3 0.8z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m647.3 135.9h2.2c1 0 1-1.5 0-1.5h-2.2c-1 0-1 1.5 0 1.5z",
    style: {
      fill: "#5f2dc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m647.7 137.9c0.2 0.6 0.5 1.2 0.7 1.8 0.1 0.4 0.5 0.6 0.9 0.5s0.7-0.5 0.5-0.9c-0.2-0.6-0.5-1.2-0.7-1.8-0.1-0.4-0.5-0.6-0.9-0.5-0.3 0-0.7 0.5-0.5 0.9z",
    style: {
      fill: "#5f2dc2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "arm_r"
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m860.4 328.5c-9.1 3-19 6.9-29.4 11.9-26.1 12.7-45.7 28.4-59.7 41.8-2.1-4-5.2-5.6-6.6-4.9-1.2 0.6-1.6 2.9-1.2 5.4-7.5-4.6-17-11.5-26.5-21.4-10.9-11.5-17.8-23-22.1-31.5-12.6 7.4-25.2 14.7-37.8 22.1 1.2 6.6 9.8 51.2 49.2 72.5 32.2 17.4 66.8 9.5 81.1 6.2 11.5-2.6 20.8-6.3 27.2-9.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m762.4 382.7c1.2 3.1 2.1 6.3 2.9 9.6 0.5 1.9 3.3 1.1 2.9-0.8-0.8-3.3-1.8-6.4-2.9-9.6-0.6-1.8-3.5-1.1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m699.5 341c2.7 23.5 12.1 37.4 17.5 44 31.6 38.9 93.6 33.4 102 32.5 12-1.2 20.6-3.8 21-2.5 0.8 2.5-27.4 20.1-62 20.5-10.3 0.1-53.4-0.9-80.5-35.5-14.7-18.7-18-38.8-19-48.5l21-10.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m701.5 382c13 13.7 26 27.3 39 41"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m739.5 429.5c-9.3-3.5-29.5-12.7-44.5-34.5-12.3-17.8-15.2-35.4-16-44 5.3 11.9 15.5 30.4 34.5 47 33.5 29.4 71.6 33.3 85 34-8.1 2.2-31.8 7.7-59-2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m843.9 184.6c-9-5.3-16.6-15.4-14.1-20.5 2.5-5.3 13.7-1.1 18-7.7 3-4.7-1.3-8.8-0.6-18.6 0.2-2.6 1.2-17.4 10.9-21.8 6.8-3.1 15.9-0.3 23.1 6.4 3.3-0.5 7.7-1.7 9.6-5.1 3.9-6.8-5.1-16.5-1.9-19.9 3.3-3.5 16.1 3.4 19.2 5.1 7.2 3.9 12.3 8.4 15.4 11.5 0.7-2.5 5.1-17.2 17.3-21.2 11.9-3.9 23.4 4.8 31.4 10.9 9.4 7.1 11.2 11.9 27.6 35.9 19.5 28.6 24.7 33.1 23.7 43-0.6 6.4-2.9 6.3-8.3 24.4-3.8 12.6-3.1 14.1-5.8 23.1-1.8 6.1-6.6 21.4-18 35.9-5.1 6.5-20.4 24.4-26.3 21.2-8.8-4.9 19.2-42.4 4.5-66.1-16.8-27-86.6-31.7-105.2-31.4-2.1 0.1-11.4 0.3-20.5-5.1z",
    style: {
      fill: "#ec7437"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m898 301.6c-2 6.5 7.4 12.4 10.7 28.1 2 9.3 0.9 17.6-0.6 23.6 5.7-0.8 13-2.4 21-5.5 7.3-2.8 13.2-6.2 17.7-9.2-3.2-15.6-6.4-31.3-9.5-46.9-29.1-0.1-37.7 4.7-39.3 9.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m909.3 328.4c11.6-3.6 23.7-10.1 32.5-18.6 1.4-1.3-0.7-3.5-2.1-2.1-8.3 8.1-20.2 14.4-31.2 17.8-1.8 0.6-1 3.5 0.8 2.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m905.4 320.6c1.2 3.4 1.7 7 6 5.7 6.5-2.1 12.8-5.7 18.9-8.7 1.7-0.8 0.2-3.4-1.5-2.6-3.6 1.7-7.2 3.4-10.9 5.1-1.5 0.7-3.1 1.6-4.7 2.1-3.1 1-3.9 0.5-4.9-2.4-0.6-1.8-3.5-1-2.9 0.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m907.5 322.8c7.4 0 14.4-1.8 21-5.3 1.7-0.9 0.2-3.5-1.5-2.6-6.1 3.2-12.5 4.9-19.4 4.9-2.1 0.1-2.1 3.1-0.1 3z",
    style: {
      fill: "#666666"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m860.4 212.6c-1.3 5.9-5.1 24.8-0.5 48.3 1.6 8.2 3.3 17.3 9.2 27.7 8.2 14.4 19.4 22.7 26.1 26.9 4.4 0.5 36.8 3.8 59.9-19.9 11.9-12.2 15.9-26 17.4-33.1 2.1 0.5 9.3 2.1 16.1-1.8 9.8-5.7 12.3-19.1 8.5-28.2-0.3-0.7-5-11.3-12.5-10.7-4.3 0.3-7.2 4.1-8.1 5.4 3-7.1 12.1-31.3 0.9-50.1-17.9-30-75.9-28.8-100.2-3.6-10.5 10.9-13.7 25.3-16.8 39.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m874.5 235.2c-1.7-1.6-0.5-6.5 0.1-8.4 0.1-0.6 0.3-1.2 0.7-1.8 0.1 0.6 0.3 1.3 0.3 1.9 0.2 1.3 0.2 2.7 0.1 4-0.1 1.2-0.6 2.6-0.6 3.8-0.6 0.7-0.5 1.1 0.2 1.3 0-0.8 0.1-1.5 0.1-2.3 0.2-2.9 0.7-5.7 1.4-8.6-1-0.1-2-0.3-2.9-0.4-0.3 4.1-0.6 8.1-0.8 12.2 0.8-0.4 1.5-0.9 2.3-1.3v0.4c0.4-1.9-2.5-2.7-2.9-0.8-0.3 1.3 0 2.4 1.3 3 1.1 0.5 2.2-0.1 2.3-1.3 0.3-4.1 0.6-8.1 0.8-12.2 0.1-1.7-2.5-2-2.9-0.4-0.8 3.3-1.4 6.6-1.6 9.9-0.1 1.7-0.3 4.5 1.9 5.1 4.7 1.4 4.6-9.2 4.4-11.7-0.1-1.8-0.2-4.5-1.8-5.8-1.3-1.1-3.1-0.5-4 0.8-2.2 3.2-3.6 11.7-0.5 14.6 1.4 1.4 3.5-0.7 2.1-2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m932.3 235.9c-0.4-1.9-0.6-3.9-0.4-5.8 0.1-1.3 0.9-5.7 2.1-2.6 1.3 3.4-0.5 8.2-2.2 11 0.7-0.2 1.4-0.4 2.1-0.5-1.6-0.8-0.9-4.3-0.7-5.6 0.1-1.2 0.1-5.1 1.3-5.8-0.7-0.3-1.5-0.6-2.2-0.9 0.8 3.8 0.7 7.6-0.1 11.4 0.9-0.1 1.8-0.2 2.7-0.4-1.2-2.9-1.2-5.8-0.2-8.7h-2.9c0.3 1.5 0.3 2.6-0.1 4.1-0.5 1.9 2.4 2.7 2.9 0.8 0.5-2 0.5-3.7 0.1-5.7-0.4-1.5-2.5-1.3-2.9 0-1.3 3.8-1 7.4 0.6 11.1 0.5 1.2 2.5 0.8 2.7-0.4 0.9-4.4 0.9-8.7 0.1-13-0.2-0.9-1.4-1.4-2.2-0.9-2.7 1.7-2.6 6.1-2.9 9-0.3 2.7-0.6 6.2 2.2 7.7 0.7 0.4 1.6 0.2 2.1-0.5 1.9-3 3-6.5 2.9-10 0-2.4-0.3-6.2-2.8-7.4-6.3-3-5.6 11.4-5 14.2 0.3 1.6 3.2 0.8 2.8-1.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m896.7 240c-4.1 6.7-9.1 15.6-9.8 23.5-0.6 5.8 7.8 7.8 12.3 7.3 1.9-0.2 1.9-3.2 0-3-2 0.2-5.8 0.3-7.3-1.4-2.7-3-0.8-7 0.3-10.2 1.9-5.2 4.3-10.1 7.2-14.8 0.9-1.5-1.7-3-2.7-1.4z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m890.9 251.8-1.2 2.1c-0.4 0.7-0.2 1.6 0.5 2.1 0.7 0.4 1.7 0.2 2.1-0.5l1.2-2.1c0.4-0.7 0.2-1.6-0.5-2.1-0.8-0.4-1.7-0.2-2.1 0.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m871.1 214c4.1 1.5 7.5 4.3 9.7 8.1 0.7 1.2 2.7 0.1 1.9-1.1-2.6-4.3-6.4-7.4-11.1-9.1-1.3-0.5-1.9 1.6-0.5 2.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m923.7 225.1c2.5-4.7 6.6-8.1 11.7-9.6 1.4-0.4 0.8-2.6-0.6-2.2-5.6 1.7-10.3 5.5-13.1 10.7-0.6 1.3 1.4 2.4 2 1.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m906.6 318.2c-0.1 0-0.1 0.1-0.2 0.1 0.6 0.1 1.2 0.2 1.8 0.2l-0.2-0.2v2.1c0.8-0.2 1.5-0.3 2.3-0.5 1.6-0.1 2.2-2.7 0.4-2.9-0.8-0.3-1.6-0.6-2.5-0.9v2.6c0.3 0 0.7 0 1 0.1v-2.9c-0.9 0-1.8-0.1-2.7-0.1-1.9-0.6-2.5 2.2-0.8 2.9 3.6 1.5 8 0.1 11.6-0.7 4.9-1 9.6-2.6 14-5-0.6-0.8-1.2-1.6-1.8-2.4-3 3-7.3 3.9-11.2 5.3-3.8 1.3-7.7 2.7-11.5 4-1.8 0.6-1.1 3.4 0.8 2.9 9.1-2.2 22.2-3 28.6-10.7 1.2-1.5-0.9-3.6-2.1-2.1-3.1 3.7-7.5 5.1-12 6.2-5.1 1.3-10.2 2.5-15.3 3.7 0.3 1 0.5 1.9 0.8 2.9 5-1.8 10-3.5 15-5.3 3.3-1.2 6.4-2.3 9-4.8 1.2-1.2-0.3-3.2-1.8-2.4-3.7 2-7.5 3.4-11.6 4.3-3.4 0.8-8.4 2.4-11.7 1.1-0.3 1-0.5 1.9-0.8 2.9 1.6 0.5 2.7 0.5 4.3 0.1 1.5-0.4 1.3-2.4 0-2.9-1.5-0.6-1.8-0.5-3.3 0.2-1.1 0.5-0.9 2 0 2.6 1.6 1 1.3 0.9 3.2 1.2 0.1-1 0.3-2 0.4-2.9-1.6 0.1-3.2 0.2-4.4 1.4-0.6 0.6-0.5 1.5 0 2.1l0.2 0.2c0.4 0.5 1.3 0.5 1.8 0.2 0.1 0 0.1-0.1 0.2-0.1 1.7-0.7 0.2-3.3-1.5-2.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m938.8 307.8c-2.7 0.9-5.2 2.2-7.4 4-1.5 1.2 0.6 3.3 2.1 2.1 1.8-1.5 3.8-2.6 6-3.3 1.9-0.5 1.1-3.4-0.7-2.8z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m894.3 287.3c10.3 0.8 20.6-7.9 26.3-15.8 0.8-1.2-1.1-2.3-1.9-1.1-5.2 7.2-14.9 15.4-24.3 14.6-1.5-0.1-1.5 2.2-0.1 2.3z",
    style: {
      fill: "#666666"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m926.2 190.7c1.9 2.6 27.2 37.6 12.2 78.1-11.5 31-38.6 43.6-43.9 45.9 4.8 0.6 31.7 3.3 54.5-15.7 16.3-13.6 21.5-30.9 23.1-37.3 8.4 1.9 17-0.8 22-7.1 5.2-6.5 4.3-14.1 3.9-16.5-0.8-4.6-4-15.2-11.8-15.7-5.3-0.3-10.9 4.1-13.3 11 3.9-8.6 3.1-14.7 2.4-17.7-3.7-14.8-23.5-26.3-49.1-25z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m896.3 240c-1.2-0.8-20.1 15.4-14.2 25.3 2.6 4.4 9.2 6.3 16.3 5.8-3.9 0-8-0.8-10.1-3.7-5.9-8.2 9.2-26.6 8-27.4z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "m973 256.3c-1.4-0.6-6.3 10.4-18.4 25.8-10.6 13.6-18.2 19.6-20.4 21.3-6.6 5.2-12.8 8.6-17.1 10.7 2.6 1.7 6.8 4.9 10 10.3 5.5 9.4 4.4 18.8 3.9 21.6 5.1-2.5 10.1-5 15.2-7.4-1.9-10.6-3.9-21.1-5.8-31.7 6-3.8 10.6-7.6 14.2-11 2.5-2.3 4.2-3.9 6.1-6.5 2.4-3.1 4.4-6.8 7.8-16.5 3.2-9.2 5.6-16.1 4.5-16.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "glasses"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "m846.6 210.5c0.1 5 6 12.9 12.7 14 7.3 1.2 11.6-6 24.7-14.3 11.4-7.2 19.4-12.3 28.6-12 18.5 0.5 21.6 20 43.9 24.1 1.1 0.2 22 3.7 34.1-9.1 10.9-11.5 11.5-32.5 0.7-51.4-119.9 22.2-145 38.1-144.7 48.7z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "m1010.1 227.5c-5.9-8.6-11.8-17.1-17.7-25.7 1.7-5.1 3.5-10.2 5.2-15.3 6.3 5.6 12.6 11.2 18.9 16.9-2.1 8-4.3 16.1-6.4 24.1z",
    style: {
      fill: "#666666"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m853.9 164.2c-12.1 13.2-15.8 29.1-9.9 40.2 0.8 1.5 4.7 8.8 12.7 11 18.2 5 29.5-24.2 54.5-23.1 10.2 0.5 20.7 5.9 24.2 7.7 10.5 5.5 15 11.1 25 12 0.3 0 7.9 0.6 14.3-2.2 13-5.7 20.3-25.3 17.5-48.3-16.5-6-45.2-13.9-81-11-24.2 1.9-43.7 8.1-57.3 13.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m876 199.7c10.8-15.5 22.9-30 36.2-43.5 1.4-1.4-0.8-3.5-2.1-2.1-13.5 13.6-25.7 28.4-36.7 44.1-1.1 1.6 1.5 3.1 2.6 1.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m905.6 190.1c5.1-6.6 10.2-13.1 15.4-19.7 1.2-1.5-0.9-3.6-2.1-2.1-5.1 6.6-10.2 13.1-15.4 19.7-1.2 1.5 0.9 3.7 2.1 2.1z",
    style: {
      fill: "#666666"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "m883.7 156.1 60.9 11.7c8.6 10.3 15.3 21.2 11.7 28.2-3.1 6.1-12.2 6-12.1 8.5 0.2 4 23.9 12.3 35.9 2 11.9-10.2 7.8-34.8-4-46.8-10.3-10.4-25.3-10-50.4-9.3-17.6 0.5-32 3.2-42 5.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand_l"
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m955.9 214.8c-0.4 1.4 4.7 4.3 9.8 5.9 6.1 1.9 10.7 1.4 16.5 1.2 5-0.2 12.1-0.2 20.9 0.7 5.4 3.4 13.3 9 21.7 17.1 15.9 15.3 17.6 24.1 28.4 27 13.3 3.6 30-4.6 30.4-11.5 0.2-3.5-3.7-6.3-5.6-7.7-10-7.4-24.4-20.4-46.4-44.7-2.3-9.4-4.6-16.9-6.4-22-2.5-7.1-3.5-8.9-5.2-15-2.8-10-1.7-11.3-3.9-17-3.7-9.3-10.9-16.5-12.2-15.7-0.8 0.4-0.3 3.7 5.4 16.2-0.4 9.4-1.5 12.2-2.8 12.4-4 0.6-6.5-25.7-20.1-29.5-8.1-2.3-18.3 4.1-17.9 6.7 0.4 2.3 9.2 2.7 16.5 2.8 0.7 3.5 1.3 7 2 10.5-0.9-0.5-2.1-1.1-3.5-1.7-15.4-6.5-33-3.2-33.2-0.4-0.1 1.4 4.1 3.6 20 7.1 1.5 0.7 4.2 2.1 6.4 5 3.7 4.9 3.4 10.3 3.3 11.8-20.7-4.2-31.4-5.2-32.1-3.2-0.5 1.6 5.2 5.2 17 10.6 5.3 4 10.5 8.1 15.8 12.1 0.8 3.7 1.6 7.4 2.3 11.1-2.1 2.4-5.4 5.5-10.1 7.4-8.7 3.4-16.6 1-17 2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m983.2 151.4c5 1.1 8.7 6.7 11.6 10.6 0.6 0.8 1.9 0 1.3-0.8-3.2-4.3-6.9-10-12.5-11.2-0.9-0.3-1.3 1.2-0.4 1.4z",
    style: {
      fill: "#666666"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m972.5 321.1c12.3-2.2 26.8-4 43.2-4.4 15.9-0.3 30.1 0.7 42.1 2.4-4.4-2.6-5.4-7.2-3.8-9.3 1.1-1.5 3.9-1.9 6.6-1.1-4-12.1-8.1-24.3-12.6-36.6-1.6-4.3-3.1-8.6-4.7-12.9 15.8-4.6 31.6-9.3 47.4-13.9 7.7 19 16 45.7 19 78.4 2.1 23 1.1 43.2-0.9 59.5-9.6 6-25 13.8-45.4 17.5-12.8 2.3-24.1 2.3-32.8 1.6l-3.6 31.2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m994.3 159.2c-0.8 0.6-5-7-13.8-10.6-7.2-2.9-15.5-2.5-16-0.6-0.5 2.1 9.4 6 14.7 8.7 23.6 11.8 24.3 32.2 51.6 70.7 7.5 10.6 14 18.9 19.6 25.7 14.1 16.9 16.8 16.6 23.2 26.3 11.1 16.7 13.9 33.3 15.2 41.3 1.9 11.7 4.1 25.3-0.4 38.6-10.7 32-52.7 41.4-57.4 42.4 9.9 1 25.7 1.4 44-3.9 14.6-4.2 25.7-10.4 33.2-15.4 3.5-21.2 5.9-52.8-1.9-89.5-4-18.6-9.7-34.4-15.5-47.3l-12.3 3c-2-1.6-4.9-4-8.3-7-8.7-7.6-10.7-10.2-21.9-21.1-12.2-11.8-13.5-12.3-15.9-16.6-2.1-3.8-1.7-4.6-5.5-17.9-4.8-16.7-5-13.9-7.6-23.9-2.9-11.2-3.1-16-7.8-22.2-3.3-4.3-7.3-7.1-8.1-6.5-0.9 0.8 4.4 6.3 5.3 15.1 0.6 5.7-0.7 12.5-2.8 12.8-4.2 0.6-5.9-25.4-19.1-29.2-8-2.3-18.1 4.1-17.6 6.5 0.4 2.1 8.8 2.4 16.1 2.3 8.1 14 9.6 17.9 9 18.3z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "m1089.6 274.7c2.1 19.7 5.5 33.8 6.2 37 3.4 15.8 0.8 41.6-26.2 85.2 5.1-0.5 11.8-1.6 19.3-4.2 8-2.9 14.2-6.6 18.5-9.6 1.6-9.5 3.1-22.6 3.1-38.2 0-53.8-18.6-99.8-22-99.1-1.9 0.4-0.3 15.7 1.1 28.9z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "m1063.4 248.5c6.5-2.4 12.1-1.3 14.3-0.8-8.1 2.6-16.2 5.1-24.3 7.7 1.5-1.7 4.7-5 10-6.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImage);
export default __webpack_public_path__ + "static/media/about-image.9a285b271d24dc9bd3aabe6c96e3d255.svg";
export { ForwardRef as ReactComponent };